<template>
    <!-- 代驾订单 -->
    <div class="box">
        <!-- 地图容器 -->
        <div id="container" @contextmenu.prevent="closeRanging"></div>

        <!-- 左侧  -->
        <div class="main-left">
            <!-- 位置信息 -->
            <div class="left-top">
                <el-row>
                    <el-col :span="24">
                        <div class="left-top-col" style="position: relative">
                            <span style="color: rgb(68, 141, 201); font-size: 20px" class="iconfont icon-zuobiaofill"></span>
                            <el-input
                                v-model="submit_data.start_name"
                                clearable
                                :disabled="distributeLeaflets_flag"
                                class="input-place"
                                @input="onInput(submit_data.start_name, '1')"
                            >
                            </el-input>
                            <ul id="start-panel" v-if="start_panel_show">
                                <li
                                    class="list"
                                    v-for="(item, index) in start_panel_innerHtml"
                                    :key="index"
                                    @click="listClick('start', item.location.lng, item.location.lat, item.name)"
                                >
                                    <div style="padding-left: 20px">
                                        <p class="list-name">
                                            <img
                                                :src="require(`@/assets/markPoint${index + 1}.png`)"
                                                alt=""
                                                style="width: 20px; height: 20px; display: inline-block"
                                            />
                                            <!--                                            {{Number(index)+11}}-->
                                            <span style="display: inline-block">{{ item.name }}</span>
                                        </p>
                                        <p class="list-address">{{ item.address }}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <div class="left-top-col" style="position: relative">
                            <span style="color: rgb(241, 123, 123); font-size: 20px" class="iconfont icon-zuobiaofill"></span>
                            <el-input
                                v-model="submit_data.end_name"
                                clearable
                                :disabled="distributeLeaflets_flag"
                                class="input-place"
                                @input="onInput(submit_data.end_name, '2')"
                            ></el-input>
                            <ul id="end-panel" v-if="end_panel_show">
                                <li
                                    class="list"
                                    v-for="(item, index) in end_panel_innerHtml"
                                    :key="index"
                                    @click="listClick('end', item.location.lng, item.location.lat, item.name)"
                                >
                                    <div style="padding-left: 20px">
                                        <p class="list-name">
                                            <span style="display: inline-block">{{ item.name }}</span>
                                        </p>
                                        <p class="list-address">{{ item.address }}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="space-between">
                    <el-col :span="19">
                        <div class="left-top-col" style="border-bottom: 0; display: flex">
                            <span style="color: rgb(255, 166, 0); font-size: 20px" class="iconfont icon-zuobiao"></span>
                            <p class="fs14-w500" style="text-indent: 10px">{{ distance }}公里 | {{ estimate }}分钟 | {{ price }}元</p>
                        </div>
                    </el-col>
                    <el-col :span="5" style="text-align: right; height: 32px; line-height: 32px">
                        <el-button
                            type="primary"
                            @click="main_right_show = !main_right_show"
                            style="padding: 5px"
                            v-if="submit_data.driver_number == ''"
                            :disabled="submit_data.assign_mode == 'ai' || submit_data.assign_mode == 'assign1'"
                        >
                            选择司机
                        </el-button>

                        <el-button
                            @click="main_right_show = !main_right_show"
                            style="padding: 5px"
                            :disabled="submit_data.assign_mode == 'ai' ? true : false"
                            v-else
                        >
                            已选{{ submit_data.driver_number }}人
                        </el-button>
                    </el-col>
                </el-row>
            </div>

            <!-- 订单信息 -->
            <div class="left-bottom">
                <el-row type="flex" justify="space-between" style="margin-top: 10px">
                    <!-- <el-col :span="24" style="text-align: center;">

                        <el-radio-group v-model="radio_mode">
                          <el-radio-button label="实时单"></el-radio-button>
                          <el-radio-button label="预约单"></el-radio-button>
                        </el-radio-group>

                      </el-col> -->
                </el-row>

                <div>
                    <!-- <el-row type="flex" justify="center" style="margin-top: 10px" v-if="radio_mode == '预约单'">
                        <el-col :span="6" class="main-left-title fs14-w500"> 预约时间： </el-col>
                        <el-col :span="18">
                            <el-date-picker
                                v-model="submit_data.order_time"
                                type="datetime"
                                placeholder="选择预约时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 200px"
                            >
                            </el-date-picker>
                        </el-col>
                    </el-row> -->

                    <!-- 第一次进入代驾订单页面，或者是创单后不刷新页面，则订单模式显示的是上一次创建订单选择的模式，如果是第一次进入代驾订单页面或者刷新页面，则显示默认模式 -->

                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"></el-col>
                        <el-col :span="18">
                            <el-radio-group
                                v-model="is_man"
                                size="mini"
                                @change="isManChange"
                                :disabled="distributeLeaflets_flag"
                            >
                                <el-radio-button
                                    label="0"

                                >
                                商务订单
                                </el-radio-button>
                                <el-radio-button
                                    label="1"

                                >
                                普通订单
                                </el-radio-button>

                            </el-radio-group>
                        </el-col>
                    </el-row>



                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 订单模式: </el-col>
                        <el-col :span="18">
                            <el-select
                                v-model="submit_data.order_mode_code"
                                placeholder="请选择订单模式"
                                style="width: 140px; margin-right: 20px"
                                clearable
                                :disabled="distributeLeaflets_flag"
                                @change="orderModeChange"
                            >
                                <el-option
                                    v-for="(item, index) in value_order_array"
                                    :label="item.name"
                                    :key="index"
                                    :value="item.order_mode.order_mode_code"
                                >
                                </el-option>
                            </el-select>

                            <el-button type="text" @click="toDefault">设为默认</el-button>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 指派模式: </el-col>
                        <el-col :span="18">
                            <el-radio-group
                                v-model="submit_data.assign_mode"
                                size="mini"
                                @change="assignChange"
                                :disabled="distributeLeaflets_flag"
                            >
                                <el-radio-button
                                    :label="index"
                                    v-for="(item, index) in assign_mode"
                                    v-if="item.checked"
                                    :key="index"
                                    :disabled="submit_data.type == ''"
                                >
                                    {{ item.alias }}
                                </el-radio-button>

                                <el-radio-button label="assign1"> 抢单大厅 </el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <el-row
                        type="flex"
                        justify="center"
                        style="margin-top: 10px"
                        v-if="
                            submit_data.assign_mode == 'assign' || submit_data.assign_mode == 'ai' || submit_data.assign_mode == 'assign1'
                        "
                    >
                        <el-col :span="6" class="main-left-title fs14-w500"> 需要司机: </el-col>
                        <el-col :span="18">
                            <el-input v-model="submit_data.order_tag_num" :disabled="distributeLeaflets_flag" style="width: 50px">
                            </el-input>
                            名
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 用户电话: </el-col>
                        <el-col :span="18" style="position: relative" class="consumer-phone-wrap">
                            <el-input
                                v-model="submit_data.consumer_phone"
                                placeholder="请输入用户电话"
                                class="handle-input"
                                :maxlength="consumer_phone_type == '手机' ? '11' : '13'"
                                style="width: 120px; margin-right: 5px"
                                @input="consumerPhone"
                                @keyup.enter.native="addOrderSubmit"
                                :disabled="distributeLeaflets_flag"
                            >
                            </el-input>
                            <el-radio-group v-model="consumer_phone_type" size="mini" style="position: absolute; right: 0; top: 5px">
                                <el-radio-button label="手机"></el-radio-button>
                                <el-radio-button label="固话"></el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 用户姓名: </el-col>
                        <el-col :span="18">
                            <el-input
                                v-model="submit_data.consumer_name"
                                placeholder="请输入用户姓名"
                                @keyup.enter.native="addOrderSubmit"
                                class="handle-input mr10"
                                style="width: 120px; margin-right: 20px"
                                :disabled="distributeLeaflets_flag"
                            >
                            </el-input>
                            <el-button type="text" @click="consumer_phone = !consumer_phone"
                                >{{ consumer_phone ? '收起用户信息' : '展开用户信息' }}
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 类型: </el-col>

                        <el-col :span="18">
                            <el-radio-group v-model="submit_data.type" size="mini">
                                <el-radio-button label="1">取送车</el-radio-button>
                                <el-radio-button label="0">实时单</el-radio-button>
                                <el-radio-button label="">预约单</el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <div v-if="submit_data.type == '1'">
                        <el-row type="flex" justify="center" style="margin-top: 10px">
                            <el-col :span="6" class="main-left-title fs14-w500"> 车架号: </el-col>
                            <el-col :span="18">
                                <el-input
                                    v-model="submit_data.vin_no"
                                    placeholder="请输入车架号"
                                    class="handle-input mr10"
                                    style="width: 220px; margin-right: 20px"
                                >
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="center" style="margin-top: 10px">
                            <el-col :span="6" class="main-left-title fs14-w500"> 车牌号: </el-col>
                            <el-col :span="18">
                                <el-input
                                    v-model="submit_data.plate"
                                    placeholder="请输入车牌号"
                                    class="handle-input mr10"
                                    style="width: 220px; margin-right: 20px"
                                >
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="center" style="margin-top: 10px">
                            <el-col :span="6" class="main-left-title fs14-w500"> 接车电话: </el-col>
                            <el-col :span="18">
                                <el-input
                                    v-model="submit_data.get_phone"
                                    placeholder="请输入接车人电话"
                                    class="handle-input mr10"
                                    style="width: 220px; margin-right: 20px"
                                >
                                </el-input>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row v-if="submit_data.type == ''" type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 预约时间： </el-col>
                        <el-col :span="18">
                            <!-- <el-date-picker
                                v-model="submit_data.order_time"
                                type="datetime"
                                placeholder="选择预约时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 200px"
                                :picker-options="pickerOptions1"
                                @focus="changeTime"
                                :default-time="defaultTime"
                            >
                            </el-date-picker> -->
                            <el-date-picker
                                v-model="submit_data.order_time"
                                type="datetime"
                                placeholder="选择预约时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 200px"
                                @focus="changeTime"
                                :default-time="defaultTime"
                            >
                            </el-date-picker>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="center" style="margin-top: 10px">
                        <el-col :span="6" class="main-left-title fs14-w500"> 订单备注: </el-col>
                        <el-col :span="18">
                            <el-input
                                type="textarea"
                                v-model="submit_data.remarks"
                                placeholder="请输入备注"
                                @keyup.enter.native="addOrderSubmit"
                                class="handle-input mr10"
                                style="width: 200px; margin-right: 20px"
                            ></el-input>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="center" style="margin-top: 20px">
                        <el-col :span="6" class="main-left-title fs14-w500"></el-col>
                        <el-col :span="18">
                            <el-button type="primary" @click="addOrderSubmit" style="padding: 6px 15px" v-if="addOrderBtn">
                                创建订单
                            </el-button>
                            <!-- 用户信息 -->
                            <div
                                v-if="consumer_phone"
                                class="consumer-bottom"
                                :class="{ active: submit_data.assign_mode != 'must' }"
                                style="background-color: rgb(248, 248, 248); border-radius: 5px; margin-top: 10px"
                            >
                                <el-table :data="consumer_data" style="width: 100%">
                                    <el-table-column label="姓名" align="center" width="200px">
                                        <template slot-scope="scope">
                                            <span class="table-text">
                                                {{ scope.row.name }}
                                            </span>
                                            <el-tag
                                                type="success"
                                                v-if="scope.row.order.length == 0 && scope.row.consumer_wallet.length == 0"
                                            >
                                                新用户
                                            </el-tag>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="账户余额" align="center">
                                        <template slot-scope="scope">
                                            <span class="table-text">
                                                {{ scope.row.consumer_wallet.balance }}
                                            </span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="提现" align="center">
                                        <template slot-scope="scope">
                                            <span class="table-text" style="color: #39a709">
                                                {{ scope.row.consumer_wallet.cash }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="冻结" align="center">
                                        <template slot-scope="scope">
                                            <span class="table-text" style="color: #f84742">
                                                {{ scope.row.consumer_wallet.frozen }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="提现中" align="center">
                                        <template slot-scope="scope">
                                            <span class="table-text" style="color: #39a709">
                                                {{ scope.row.consumer_wallet.cashing }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="拖欠款" align="center">
                                        <template slot-scope="scope">
                                            <span class="table-text">
                                                {{ scope.row.consumer_wallet.arrears }}
                                            </span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="总下单量" align="center">
                                        <template slot-scope="scope">
                                            <span class="table-text" style="color: #b46f06">
                                                {{ scope.row.order_count }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <el-table :data="order_ongoing" style="width: 100%; max-height: 300px" v-if="order_ongoing.length != 0">
                                    <el-table-column label="司机姓名" align="center" width="100px">
                                        <template slot-scope="scope">
                                            <span style="color: red">
                                                {{ scope.row.driver_real_name }}
                                            </span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="司机电话" align="center" min-width="90px">
                                        <template slot-scope="scope">
                                            <span style="color: red">
                                                {{ scope.row.driver_phone }}
                                            </span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="起点" align="center" min-width="300px">
                                        <template slot-scope="scope">
                                            <span style="color: red">
                                                {{ scope.row.start_name }}
                                            </span>
                                            <el-button
                                                icon="el-icon-upload2"
                                                style="padding: 2px"
                                                v-if="scope.row.start_name != ''"
                                                @click="thisRouteStart(scope.row.start_coordinate, scope.row.start_name)"
                                            ></el-button>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="订单时间" align="center" min-width="150px">
                                        <template slot-scope="scope">
                                            <span style="color: red">
                                                {{ scope.row.order_time.YmdHis }}
                                            </span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="查看" align="center" min-width="150px">
                                        <template slot-scope="scope">
                                            <el-button style="padding: 8px 10px" @click="toOrderList(scope.row.billno)">查看</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <el-table
                                    :data="consumer_data[0].order"
                                    style="width: 100%; max-height: 300px"
                                    v-if="consumer_data[0].order.length != 0"
                                >
                                    <el-table-column label="起点" align="center" min-width="300px">
                                        <template slot-scope="scope">
                                            {{ scope.row.start_name }}
                                            <el-button
                                                icon="el-icon-upload2"
                                                style="padding: 2px"
                                                v-if="scope.row.start_name != ''"
                                                @click="thisRouteStart(scope.row.start_coordinate, scope.row.start_name)"
                                            ></el-button>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="终点" align="center" min-width="300px">
                                        <template slot-scope="scope">
                                            {{ scope.row.end_name }}
                                            <el-button
                                                icon="el-icon-upload2"
                                                style="padding: 2px"
                                                v-if="scope.row.end_name != ''"
                                                @click="thisRouteEnd(scope.row.end_coordinate, scope.row.end_name)"
                                            ></el-button>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="订单时间" align="center" width="150px">
                                        <template slot-scope="scope">
                                            {{ scope.row.order_time.YmdHis }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>

                            <el-button type="primary" style="padding: 6px 15px" disabled v-if="!addOrderBtn">
                                <i class="el-icon-loading"></i>
                            </el-button>

                            <el-button type="success" @click="toTransferOrder" style="padding: 6px 15px" v-if="distributeLeaflets_flag">
                                协助指派
                            </el-button>

                            <el-button type="text" @click="transferOrderCancel" v-if="distributeLeaflets_flag"> 取消 </el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <!--  创建优惠券  -->
        <div class="red-money" v-if="isShowValueY == true">
            <el-form>
                <!-- 需提交后台 -->
                <el-form-item label="优惠券名称 :" label-width="150px">
                    <el-select
                        v-model="mapCouponData.coupon_mode_code"
                        placeholder="请选择优惠券名称"
                        style="width: 140px; margin-right: 20px"
                        clearable
                        @change="couponChange"
                        @visible-change="visibleChange"
                    >
                        <el-option v-for="item in mapCouponArray" :key="item.value" :label="item.name" :value="item.coupon_mode_code">
                        </el-option>
                        <el-pagination
                            class="pagination"
                            layout="prev, pager, next"
                            :total="selectPages_coupon_data.count"
                            :page-size="coupon_options_data.limit"
                            @current-change="selectPages_coupon_function"
                            :current-page="coupon_options_data.page"
                        />
                    </el-select>
                </el-form-item>

                <!-- 需提交后台 -->
                <el-form-item label="最大发放数 :" label-width="150px">
                    <el-input disabled v-model="mapCouponDataDisplay.surplus_num" clearable> </el-input>
                </el-form-item>
                <el-form-item label="发放数量 :" label-width="150px">
                    <el-input v-model="mapCouponData.grant_num" clearable> </el-input>
                </el-form-item>

                <!-- 使用时间需接口重新返回值  use_time:['2024-03-31', '2024-04-10'] -->
                <el-form-item label="使用时间 :" label-width="150px">
                    <el-date-picker
                        v-model="mapCouponDataDisplay.time"
                        disabled
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 230px"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="可持有数量 :" label-width="150px">
                    <el-input disabled v-model="mapCouponDataDisplay.max_hold_count" clearable> </el-input>
                </el-form-item>
                <el-form-item label="总领取次数 :" label-width="150px">
                    <el-input disabled v-model="mapCouponDataDisplay.max_count" clearable> </el-input>
                </el-form-item>
                <!-- <el-form-item label="领取距离 :" label-width="150px">
                    <el-input v-model="mapCouponData.distance" clearable> </el-input>
                </el-form-item> -->
            </el-form>

            <div class="button-group">
                <el-button type="primary" @click="grantyCoupon" :loading="coupon_loading">确认发放</el-button>
                <el-button @click="couponCancel">取消</el-button>
            </div>
        </div>

        <!--  创建红包  -->
        <div class="red-money" v-if="isShowValue == true">
            <div style="text-align: center; margin: 10px 0; color: red">{{ redTitle }}</div>
            <el-form>
                <el-form-item label="红包类型 :" label-width="150px">
                    <el-select v-model="redMoneyType" placeholder="请选择" @change="redChange">
                        <el-option key="1" label="定点红包" value="1"> </el-option>
                        <el-option key="2" label="随机红包" value="2"> </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="redMoneyType == '1'">
                    <el-form-item label="领取次数 :" label-width="150px">
                        <el-input v-model="redMoney.num" clearable> </el-input>
                    </el-form-item>
                    <el-form-item label="红包金额 :" label-width="150px">
                        <el-input v-model="redMoney.price" clearable> </el-input>
                    </el-form-item>
                    <el-form-item label="领取距离 :" label-width="150px">
                        <el-input v-model="redMoney.distance" clearable> </el-input>
                    </el-form-item>
                </div>
                <div v-if="redMoneyType == '2'">
                    <el-form-item label="红包个数 :" label-width="150px">
                        <el-input v-model="redMoneySj.position_num" clearable> </el-input>
                    </el-form-item>
                    <el-form-item label="红包金额 :" label-width="150px">
                        <el-input v-model="redMoneySj.price" clearable> </el-input>
                    </el-form-item>
                    <el-form-item label="领取距离 :" label-width="150px">
                        <el-input v-model="redMoneySj.distance" clearable> </el-input>
                    </el-form-item>
                    <el-form-item label="领取次数 :" label-width="150px">
                        <el-input v-model="redMoneySj.num" clearable> </el-input>
                    </el-form-item>
                </div>
                <div style="padding: 0 20px 20px">
                    <div style="text-align: left; padding-left: 27px">发放说明：</div>
                    <div>
                        <div class="red-father">
                            <div class="red-money-style">红包个数：</div>
                            <div class="red-money-word">发放的红包数量</div>
                        </div>
                        <div class="red-father">
                            <div class="red-money-style">领取次数：</div>
                            <div class="red-money-word">每个红包可被领取的次数，(例如：可领取次数为5，当前位置红包可被领取5次)</div>
                        </div>
                        <div class="red-father">
                            <div class="red-money-style">领取距离：</div>
                            <div class="red-money-word">当前红包位置X米范围内都可领取</div>
                        </div>
                    </div>
                </div>
            </el-form>

            <div class="button-group">
                <el-button type="primary" @click="grantRedMoney" :loading="grant_loading">确认发放</el-button>
                <el-button @click="redMoneyCancel">取消</el-button>
            </div>
        </div>

        <!--  红包详情  -->
        <div class="red-money details" v-if="RedMoneyDetailas_show">
            <div class="row-item">
                <div>
                    <p>金额:</p>
                    <span>{{ redMoneyDetailas.price }}元</span>
                </div>

                <div>
                    <p>数量:</p>
                    <span>{{ redMoneyDetailas.num }}</span>
                </div>
                <div>
                    <p>距离:</p>
                    <span>{{ redMoneyDetailas.distance }}米</span>
                </div>

                <div>
                    <p>剩余数量:</p>
                    <span>{{ redMoneyDetailas.surplus_num }}</span>
                </div>
            </div>

            <div class="button-group">
                <el-button type="danger" @click="delRedMoney(redMoneyDetailas.positioning_reward_code)" :loading="grant_loading"
                    >删除红包</el-button
                >
                <el-button @click="redMoneyDetailsCancel">关闭</el-button>
            </div>
        </div>
        <!--  优惠券详情  -->
        <div class="red-money details" v-if="couponDetailas_show">
            <div class="row-item">
                <div>
                    <p>优惠券名称:</p>
                    <span>{{ couponDetailas.coupon_name }}元</span>
                </div>

                <div>
                    <p>已领取数量:</p>
                    <span>{{ couponDetailas.receive_num }}</span>
                </div>

                <div>
                    <p>剩余数量:</p>
                    <span>{{ couponDetailas.surplus_num }}</span>
                </div>
            </div>

            <div class="button-group">
                <el-button type="danger" @click="deleteMapCoupon(couponDetailas.map_coupon_code)" :loading="coupon_loading"
                    >删除优惠券</el-button
                >
                <el-button @click="couponDetailsCancel">关闭</el-button>
            </div>
        </div>

        <div class="main-right-ai" v-if="submit_data.assign_mode == 'ai'">
            <div class="block">
                <span class="demonstration fs14-w500"> AI距离({{ slider_km }}公里) </span>
                <el-slider
                    v-model="slider"
                    :step="5"
                    :min="5"
                    show-stops
                    style="padding-right: 10px"
                    @change="sliderChange"
                    :show-tooltip="false"
                >
                </el-slider>
            </div>
            <p style="padding-left: 25px; font-size: 12px; font-weight: 400; color: red">*注：订单会在选定的AI距离内搜索司机进行匹配</p>

            <div class="block">
                <span class="demonstration fs14-w500">AI匹配人数(/单)({{ matching.radius_slider_num }}人)</span>
                <el-slider
                    v-model="matching.radius_slider_driver"
                    class="slider-driver"
                    :step="20"
                    show-stops
                    @change="matchingSliderDriverChange"
                    :show-tooltip="false"
                    style="padding-left: 10px"
                >
                </el-slider>
            </div>

            <p style="padding-left: 25px; font-size: 12px; font-weight: 400; color: red">*注：每需要一名代驾员需要匹配多少名代驾员抢单</p>

            <el-table
                :data="rightToptableData"
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                v-loading="loading"
                @cell-mouse-enter="mainRightTableEnter"
                @cell-mouse-leave="mainRightTableLeave"
                max-height="200"
            >
                <el-table-column label="姓名" min-width="80" fixed align="center">
                    <template slot-scope="scope">
                        {{ scope.row.real_name }}
                    </template>
                </el-table-column>

                <el-table-column prop="linear_distance" label="直线/实际" min-width="120" align="center">
                    <template slot-scope="scope">
                        {{ Math.floor(scope.row.linear_distance / 10) / 100 }}km /
                        {{ scope.row.distance == '--' ? scope.row.distance : Math.floor(scope.row.distance / 10) / 100 }}km
                    </template>
                </el-table-column>

                <el-table-column prop="duration" label="分数" min-width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.monitor_point }}
                    </template>
                </el-table-column>

                <el-table-column prop="phone" label="电话" min-width="100" align="center"> </el-table-column>
            </el-table>
        </div>

        <!-- 推荐服务人员 -->
        <div class="main-right" v-if="main_right_show && submit_data.assign_mode != 'assign1'">
            <div class="right-top" :class="{ 'put-long': put }">
                <h4 class="title">推荐服务人员</h4>

                <div class="right-top-search-btn-group">
                    <el-button style="padding: 4px 8px" :type="actual ? 'primary' : ''" @click="actualBtn"> 实际距离 </el-button>
                    <el-button
                        style="padding: 4px 8px"
                        :type="right_top_search_btn == 'distance' ? 'primary' : ''"
                        @click="rightTopSearchBtn('distance')"
                    >
                        距离
                        <i class="el-icon-top"></i>
                    </el-button>
                    <el-button
                        style="padding: 4px 8px"
                        :type="right_top_search_btn == 'points' ? 'primary' : ''"
                        @click="rightTopSearchBtn('points')"
                    >
                        分数
                        <i class="el-icon-top"></i>
                    </el-button>
                    <el-button
                        style="padding: 4px 8px"
                        @click="put = !put"
                        :class="{ 'el-icon-d-arrow-right': !put, 'el-icon-d-arrow-left': put }"
                    >
                    </el-button>
                </div>

                <i
                    class="el-icon-refresh"
                    style="font-size: 20px; cursor: pointer; float: right; font-weight: 800"
                    @click="searchDriver(search_driver_data.lng, search_driver_data.lat, slider_km)"
                ></i>

                <div class="block">
                    <span class="demonstration fs14-w500">搜索半径({{ slider_km }}公里)</span>
                    <el-slider v-model="slider" :step="5" :min="5" show-stops @change="sliderChange" :show-tooltip="false"> </el-slider>
                </div>

                <div class="block">
                    <span class="demonstration fs14-w500">搜索人数({{ search_driver_num }}人)</span>
                    <el-slider
                        v-model="slider_driver"
                        class="slider-driver"
                        :step="5"
                        :min="5"
                        show-stops
                        @change="sliderDriverChange"
                        :show-tooltip="false"
                    >
                    </el-slider>
                </div>

                <el-table
                    :data="rightToptableData"
                    @selection-change="handleSelectionChange"
                    ref="multipleTable"
                    v-loading="loading"
                    @cell-mouse-enter="mainRightTableEnter"
                    @cell-mouse-leave="mainRightTableLeave"
                    max-height="200"
                >
                    <el-table-column type="selection" width="45" align="center" prop="driver_code"></el-table-column>

                    <el-table-column prop="real_name" label="姓名" min-width="120" fixed align="center">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <!--司机段位图片-->
                                <img
                                    style="width: 30px; height: 30px; margin-right: 5px; display: inline-block"
                                    :src="
                                        scope.row.dan == 0
                                            ? require('@/assets/11.png')
                                            : scope.row.dan == 1
                                            ? require('@/assets/22.png')
                                            : scope.row.dan == 2
                                            ? require('@/assets/33.png')
                                            : require('@/assets/44.png')
                                    "
                                />

                                <!--司机姓名-->
                                <p style="display: block">
                                    {{ scope.row.real_name }}
                                </p>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="linear_distance" label="直线/实际" min-width="120" align="center">
                        <template slot-scope="scope">
                            {{ Math.floor(scope.row.linear_distance / 10) / 100 }}km /
                            {{ scope.row.distance == '--' ? scope.row.distance : Math.floor(scope.row.distance / 10) / 100 }}km
                        </template>
                    </el-table-column>

                    <el-table-column prop="duration" label="分数" min-width="80" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.monitor_point }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="duration" label="骑行" min-width="50" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.duration == '--' ? scope.row.duration : Math.ceil(scope.row.duration / 60) }}分
                        </template>
                    </el-table-column>

                    <el-table-column prop="phone" label="电话" min-width="100" align="center"> </el-table-column>

                    <el-table-column label="今日完成" min-width="100">
                        <template slot-scope="scope"> ￥{{ scope.row.sum_num }}( {{ scope.row.count_num }}单) </template>
                    </el-table-column>

                    <el-table-column label="今日听单时长" min-width="120">
                        <template slot-scope="scope"> {{ Math.ceil(scope.row.today_online_time / 60) }}分钟 </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-table
                class="appointment-table"
                v-if="appointment_show"
                :data="appointment_data"
                style="width: 450px; float: left; max-height: 120px"
                empty-text="暂无"
            >
                <el-table-column label="起点" align="center"> </el-table-column>

                <el-table-column label="终点" align="center"> </el-table-column>
                <el-table-column label="预约时间" align="center"> </el-table-column>
            </el-table>
        </div>

        <!-- 待派单列表 -->

        <div class="need-driver" v-if="need_driver.length != 0">
            <el-table :data="need_driver" style="width: 100%; border: 1px solid #eee" max-height="200">
                <el-table-column label="操作" width="300" fixed>
                    <template slot-scope="scope">
                        <el-button type="text" @click="distributeLeaflets(scope.row.order_details)"> 协助指派 </el-button>

                        <el-button type="text" @click="addOrderToAI(scope.row.order_details)"> 一键AI </el-button>

                        <el-button type="text" @click="toSales(scope.row.order_details.billno)"> 去销单 </el-button>

                        <el-button type="text" @click="salesAndToDistributeLeaflets(scope.row.order_details)"> 销单并重新指派 </el-button>
                    </template>
                </el-table-column>

                <el-table-column prop="order_details.order_type.alias" label="订单类型" width="95"> </el-table-column>

                <el-table-column prop="order_details.consumer_name" label="用户姓名" width="95"> </el-table-column>
                <el-table-column prop="order_details.consumer_phone" label="用户电话" width="100"> </el-table-column>
                <el-table-column prop="order_details.start_name" label="起点" width="200"> </el-table-column>

                <el-table-column prop="order_details.platform.alias" label="下单平台" width="80"> </el-table-column>
            </el-table>
        </div>

        <!-- 功能按钮 -->
        <el-row class="btnGroup">
            <el-button type="primary" v-for="(item, index) in btn" :key="index" :name="item.name" @click="ThingsDeg(index)">
                {{ item.text }}
            </el-button>
        </el-row>

        <tipModel :isShow="tipModel_isShow" :data="tipModel_data" :type_data="tipModel_type"></tipModel>

        <!-- 下单成功提示框 -->
        <addOrderTip :isShow="addOrderTip_isShow" :data="addOrderTip_data" :type_data="addOrderTip_type"></addOrderTip>
    </div>
</template>

<script>
var trafficLayer;
var ruler1;
var infoWindow;
var _this,
    text,
    circle,
    marker,
    polyline1,
    polyline2,
    polyline3,
    contextMenu,
    contextMenuPositon,
    msgDig,
    placeSearch,
    leagueMarker,
    map,
    driving,
    couponMarker,
    startMarker,
    endMarker,
    redMarker;

var markers = [];
import axios from 'axios'; // AJAX封装类
import { config } from '../../../utils/config'; //配置
import bus from '../../common/bus';
import tipModel from './tips.vue';
import addOrderTip from './addOrderTip.vue';

export default {
    components: {
        tipModel,
        addOrderTip
    },

    created() {
        _this = this;

        bus.$on('firstlog', (msg) => {
            _this.firstlog = msg;
        });

        _this.$nextTick(function () {
            _this.onSocket();
        });

        // 获取司机状态
        _this
            .$post('/driver/statusConf')
            .then((res) => {
                _this.checbBoxText = res.data;
            })
            .catch((err) => {});

        setTimeout(() => {
            // 地图初始化
            map = new AMap.Map('container', {
                //是否监控地图容器尺寸变化
                resizeEnable: true,
                //初始化地图层级
                zoom: 11,
                // 主题设置
                mapStyle: ''
            });

            var limit_num = 10;
            if (localStorage.getItem('city_tag') == 'KUNMING') {
                limit_num = 500;
            }

            // 联盟商家坐标
            _this
                .$post('/admin.php/Business/ipcShoppingLists', {
                    page: 1,
                    limit: limit_num,
                    shop_name: ''
                })
                .then((res) => {
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            leagueMarker = new AMap.Marker({
                                icon: new AMap.Icon({
                                    image: require('@/assets/League.png'),
                                    size: new AMap.Size(25, 34), //图标大小
                                    imageSize: new AMap.Size(25, 34)
                                }),
                                position: [res.data[i].lng, res.data[i].lat],
                                size: new AMap.Size(25, 34),
                                offset: new AMap.Pixel(-13, -30)
                            });
                            leagueMarker.setMap(map);
                        }
                    }
                })
                .catch((err) => {});

            map.on('rightclick', function (e) {
                contextMenu.open(map, e.lnglat);
                contextMenuPositon = e.lnglat;
                if (_this.start_panel_show) {
                    _this.start_panel_show = false;
                }

                if (_this.end_panel_show) {
                    _this.end_panel_show = false;
                }
            });

            //创建右键菜单
            var contextMenu = new AMap.ContextMenu();
            // 判断是否有权限

                _this.$post(
                    "/mine/adminConfig",
                    _this.search_data
                ).then(res => {
                    if (res.data.map_coupon == '1') {
                        //右键创建优惠券
                        contextMenu.addItem('创建优惠券', function () {
                            // 显示创建优惠券
                            _this.isShowValueY = true;
                            if (_this.isShowValue) {
                                _this.isShowValue = false;
                            }

                            // 记录发放优惠券定位
                            _this.mapCouponData.lng = contextMenuPositon.lng;
                            _this.mapCouponData.lat = contextMenuPositon.lat;

                            // _this.addRedMoney(contextMenuPositon.lng, contextMenuPositon.lat);

                            //右键添加点标记
                            _this.beforeAddCoupon(contextMenuPositon.lng, contextMenuPositon.lat);
                        });
                    }
                })



            // 判断是否有权限 mine/tokenDetails接口里面有positioning_reward的值，已经被缓存
            if (JSON.parse(localStorage.getItem('login')).positioning_reward == '1') {
                //右键创建红包
                contextMenu.addItem(
                    '创建红包',
                    function () {
                        // 显示创建红包
                        _this.isShowValue = true;
                        if (_this.isShowValueY) {
                            _this.isShowValueY = false;
                        }

                        // 如果是定点红包，则获取点击位置的坐标点
                        if (_this.redMoneyType == '1') {
                            // 记录发放红包定位
                            _this.redMoney.lng = contextMenuPositon.lng;
                            _this.redMoney.lat = contextMenuPositon.lat;

                            // _this.addRedMoney(contextMenuPositon.lng, contextMenuPositon.lat);

                            _this.beforeAddRedMoney(contextMenuPositon.lng, contextMenuPositon.lat);
                        } else {
                            _this.beforeAddRedMoneySj();
                        }
                    },
                    0
                );
            }

            //右键添加起点
            contextMenu.addItem(
                '创建起点',
                function () {
                    // 添加起点标记
                    _this.startMark(contextMenuPositon.lng, contextMenuPositon.lat);
                    _this.startName(contextMenuPositon);
                },
                0
            );

            //右键添加终点
            contextMenu.addItem(
                '创建终点',
                function () {
                    // 添加终点标记
                    _this.endMark(contextMenuPositon.lng, contextMenuPositon.lat);
                    _this.endName(contextMenuPositon);
                },
                0
            );

            //右键添加清除所有坐标点
            contextMenu.addItem(
                '清除所有坐标点',
                function () {
                    _this.rightToptableData = [];
                    // 清空地图上所有覆盖物
                    _this.clearMap();
                },
                0
            );

            // 使用地图工具(平移工具，测距工具)
            AMap.plugin(['AMap.RangingTool', 'AMap.CitySearch', 'AMap.Geocoder', 'AMap.Driving'], function () {
                map.addControl(new AMap.CitySearch());
            });
            // 将地图绑定点击事件   点击关闭信息窗口
            map.on('click', this.closePop);

            // 路况图层
            trafficLayer = new AMap.TileLayer.Traffic({
                zIndex: 10
            });
            // 测距功能
            ruler1 = new AMap.RangingTool(map);
            // 将路况图层加入到地图
            trafficLayer.setMap(map);
            // 隐藏路况图层
            trafficLayer.hide();
            // 弹出提示
            map.on('complete', function () {
                // 请求城市列表接口   获取围栏信息
                _this
                    .$post('/admin.php/city/getCityDetails')
                    .then((res) => {
                        if (res.data.free_area_coordinate_array != null && res.data.free_area_coordinate_array != '[]') {
                            var path1 = JSON.parse(res.data.free_area_coordinate_array);

                            path1.push(JSON.parse(res.data.free_area_coordinate_array)[0]);
                        }

                        if (res.data.far_area_coordinate_array != null && res.data.far_area_coordinate_array != '[]') {
                            var path2 = JSON.parse(res.data.far_area_coordinate_array);

                            path2.push(JSON.parse(res.data.far_area_coordinate_array)[0]);
                        }

                        if (res.data.effective_area_coordinate_array != null && res.data.effective_area_coordinate_array != '[]') {
                            var path3 = JSON.parse(res.data.effective_area_coordinate_array);

                            path3.push(JSON.parse(res.data.effective_area_coordinate_array)[0]);
                        }

                        // 创建小围栏(绿色)
                        polyline1 = new AMap.Polyline({
                            path: path1,
                            isOutline: true,
                            outlineColor: 'transparent',
                            borderWeight: 3,
                            strokeColor: 'green',
                            strokeOpacity: 0.5,
                            strokeWeight: 6,
                            // 折线样式还支持 'dashed'
                            strokeStyle: 'solid',
                            // strokeStyle是dashed时有效
                            strokeDasharray: [10, 5],
                            lineJoin: 'round',
                            lineCap: 'round',
                            zIndex: 50
                        });
                        polyline1.setMap(map);

                        if (path2) {
                            // 创建大围栏(粉色)
                            polyline2 = new AMap.Polyline({
                                path: path2,
                                isOutline: true,
                                outlineColor: 'transparent',
                                borderWeight: 3,
                                strokeColor: '#FF33FF',
                                strokeOpacity: 0.5,
                                strokeWeight: 6,
                                // 折线样式还支持 'dashed'
                                strokeStyle: 'solid',
                                // strokeStyle是dashed时有效
                                strokeDasharray: [10, 5],
                                lineJoin: 'round',
                                lineCap: 'round',
                                zIndex: 50
                            });

                            polyline2.setMap(map);
                        }

                        if (path3) {
                            // 创建大围栏(黑色)
                            polyline3 = new AMap.Polyline({
                                path: path3,
                                isOutline: true,
                                outlineColor: 'transparent',
                                borderWeight: 3,
                                strokeColor: 'black',
                                strokeOpacity: 0.5,
                                strokeWeight: 6,
                                // 折线样式还支持 'dashed'
                                strokeStyle: 'solid',
                                // strokeStyle是dashed时有效
                                strokeDasharray: [10, 5],
                                lineJoin: 'round',
                                lineCap: 'round',
                                zIndex: 50
                            });
                            polyline3.setMap(map);
                        }

                        var loginCityName = JSON.parse(localStorage.getItem('login')).city.name;

                        var x = res.data.name.indexOf('/');

                        for (var i = 0; i < 1; i++) {
                            x = res.data.name.indexOf('/', x + 1);
                        }

                        // 如果为市级
                        if (x < 0) {
                            // 截取城市名称 如:XXXX / 截取字段
                            var city_name = res.data.name.slice(res.data.name.indexOf('/') + 2);
                        } else {
                            // 截取城市名称 如:XXXX / XXXX / 截取字段
                            var city_name = loginCityName.slice(x + 2);
                        }

                        // console.log(res.data.name);

                        if (res.data.area_code.length == 4) {
                            _this.area_code = String(res.data.area_code) + '00';
                        } else {
                            _this.area_code = String(res.data.area_code);
                        }

                        // 将城市赋值
                        _this.currentCity = city_name;

                        //地图显示当前城市
                        map.setCity(_this.area_code, function (params) {
                            if (x < 0) {
                                // 设置地图层级
                                map.setZoom(11);
                            } else {
                                // 设置地图层级
                                map.setZoom(14);
                            }
                        });

                        _this.orderModeLists();

                        _this.getMapCouponList();

                        log.success('地图加载完成！');
                    })
                    .catch((err) => {});
            });

            // 获取订单最多共同司机数量
            _this
                .$post('/conf/confLists', {
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                })
                .then((res) => {
                    for (const key in res.data) {
                        if (res.data[key].conf_key == 'order_tag_num_max') {
                            _this.driver_number = Number(res.data[key].conf_value);
                        }
                    }
                })
                .catch((err) => {});
        }, 1);
    },

    beforeUpdate() {
        // _this.onSocket();
    },
    data() {
        return {
            selectPages_coupon_data: [], // 优惠券下拉选分页数据
            coupon_options_data: {
                // 获取优惠券列表的参数
                page: 1,
                limit: 10,
                status: '1'
            },
            grant_loading: false,
            coupon_loading: false,
            mapCouponArray: [], // 优惠券数组
            mapCouponDataDisplay: {
                surplus_num: '',
                time: "['2024-04-01','2024-04-11']",
                max_hold_count: '',
                max_count: ''
            },

            // search_time: [], // 优惠券使用时间

            defaultTime: '12:00:00', //预约时间默认时间
            pickerOptions1: {
                disabledDate(time) {
                    var thatDay = time.getTime(); // 点击时间控件打开的图形中显示的时间
                    // console.log(thatDay,'--------');

                    // _this.default_value = new Date(threeMonths)

                    // 点击时间控件打开的图形中显示时间如果 等于 当前日期，禁用，不可选择
                    // console.log(Date.now(), '42343-=-===');
                    // return thatDay < (Date.now() - 3600 * 1000 * 24);
                    return thatDay < _this.computingTime();
                },
                selectableRange: '00:00:00 - 23:59:59'
            },
            type: '实时单',
            redTitle: '红包位置：创建的起点',
            redMoneyType: '1', // 发放红包的红包类型，随机或者定点
            isShowValue: false,
            isShowValueY: false,
            addOrderBtn: true,

            firstlog: true,

            is_man:0,

            assign_mode: JSON.parse(localStorage.getItem('login')).assign_mode,

            markPoint: [],

            //红包详情显示开关
            RedMoneyDetailas_show: false,
            couponDetailas_show: false,

            //红包详情数据
            redMoneyDetailas: {
                distance: '',
                num: '',
                price: '',
                surplus_num: '',
                positioning_reward_code: ''
            },
            //优惠券详情数据
            couponDetailas: {
                coupon_name: '',
                receive_num: '',
                surplus_num: '',

                map_coupon_code: ''
            },
            // 优惠券发放提交数据
            mapCouponData: {
                coupon_mode_code: '',
                grant_num: '',
                // distance: '',
                lng: '',
                lat: ''
            },

            //定点红包提交数据
            redMoney: {
                price: '',
                num: '',
                distance: '',
                lng: '',
                lat: ''
            },
            //随机红包提交数据
            redMoneySj: {
                price: '',
                num: '',
                distance: '',
                position_num: ''
            },

            socket_relink_num: 0,

            sendData: {
                ws_mode: '',
                port: 'admin',
                platform: 'pc',
                token: '',
                hash_key: ''
                // city_tag: 'CHANGCHUN'
            },

            // 预约单信息
            appointment_show: false,
            appointment_data: [],

            //控制推荐服务人员表格宽度按钮
            put: false,

            tipModel_isShow: false,
            tipModel_data: '',
            tipModel_type: '',

            addOrderTip_isShow: false,
            addOrderTip_data: '',
            addOrderTip_type: '',

            // 协助指派标记
            distributeLeaflets_flag: false,

            loading: false,

            driver: [],

            driverMarks_status: [],

            search_driver_data: {
                lng: '',
                lat: ''
            },
            end: {
                lng: '',
                lat: ''
            },

            radio_mode: '实时单',

            // 需要司机最大人数
            driver_number: 5,

            // 实际距离按钮
            actual: false,

            // 行政编码
            area_code: '',

            consumer_phone: false,
            consumer_data: [],
            consumer_order_remarks: '',
            consumer_phone_type: '手机',
            order_ongoing: [],

            // 公里数
            distance: '0',

            // 预估时间
            estimate: '0',

            start_panel_show: false,
            end_panel_show: false,

            start_panel_innerHtml: [],
            end_panel_innerHtml: [],

            // 模式下拉
            value_order: '',
            value_order_array: [],
            strategy: '', //司机导航规划策略

            right_top_search_btn: localStorage.getItem('order_by') == null ? 'distance' : localStorage.getItem('order_by'),

            // 推荐服务人员显示开关
            main_right_show: false,

            need_driver: [],

            // AI派单匹配滑块
            matching: {
                radius_slider_driver: 40,
                radius_slider_num: 3
            },

            redMarker: [],
            couponMarker: [],

            // 滑块
            slider: 15,
            slider_km: 3,

            slider_driver: 50,
            search_driver_num: 10,

            // 右上表格数据
            rightToptableData: [],

            // 当前城市
            currentCity: '',

            price: '0',

            // 表单数据
            submit_data: {
                driver_code: '',
                order_mode_code: '',
                order_code: '',
                start_name: '',
                start_coordinate: '',
                end_name: '',
                end_coordinate: '',
                consumer_name: '',
                consumer_phone: '',
                order_time: '',
                driver_number: '',
                remarks: '',
                assign_mode: localStorage.getItem('assign_mode') ? localStorage.getItem('assign_mode') : 'assign',
                order_tag_num: '1',
                type: '0',
                vin_no: '',
                plate: '',
                get_phone: ''
            },

            // 判断路况图层是否显示的开关
            isVisible: false,

            // 城市列表拉出开关
            city_group_show: false,

            table_more_show: false,

            search_driver_name: '',

            // 司机头像路径
            url: '',

            // 城市名称
            city_name_group: [],

            btn: [
                {
                    text: '路况'
                },
                {
                    text: '标准',
                    name: 'amap://styles/normal'
                },
                {
                    text: '黑夜',
                    name: 'amap://styles/dark'
                },
                {
                    text: '测距'
                }
            ],

            newOrder: [],

            newOrderMore: [],

            checkList: [],
            checbBoxText: []
        };
    },
    watch: {
        firstlog() {
            if (_this.firstlog) {
                _this.onSocket();
            } else {
                // 关闭socket
                if (_this.global.ws) {
                    _this.global.ws.close();
                }
            }
        }
    },
    methods: {
        visibleChange(val) {
            if (val) {
                _this.CouponModeLists();
            }
        },
        // 发放优惠券接口
        addMapCoupon() {
            // console.log('发放优惠券');

            _this
                .$post('/map/addMapCoupon', _this.mapCouponData)
                .then((res) => {
                    this.$message.success(res.msg);

                    // 发放成功关闭页面
                    _this.couponCancel();
                    _this.getMapCouponList();
                })
                .catch((err) => {});
        },

        // 发放优惠券之前在地图上添加点标记

        beforeAddCoupon(lng, lat) {
            // console.log(couponMarker, 'couponMarker');
            if (couponMarker) {
                map.remove(couponMarker);
            }
            var couponIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(26, 35),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                // 图标所用图片大小
                imageSize: new AMap.Size(26, 35),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(0, 0)
            });

            // 将 icon 传入 marker
            couponMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                icon: couponIcon,
                draggable: false,
                offset: new AMap.Pixel(-10, -15),
                zIndex: 999
            });

            // console.log(couponMarker, 'couponMarker创建以后');

            map.add(couponMarker); // 添加点标记
        },
        // 创建优惠券的时候优惠券change事件
        couponChange(val) {
            // 获取优惠券剩余数量接口需要传的参数
            _this.getCouponCode = val;
            if (val == '' || val == null) {
                // 如果创建优惠券选择优化券以后清空或者未选择优惠券
                _this.mapCouponDataDisplay = {
                    surplus_num: '',
                    time: '',
                    max_hold_count: '',
                    max_count: ''
                };
            } else {
                _this.getGrantMapCouponNum(); // 获取最大发放数
            }

            if (_this.mapCouponArray.length > 0) {
                for (let i = 0; i < _this.mapCouponArray.length; i++) {
                    // console.log(_this.mapCouponArray[i], '遍历优惠券数组');
                    // 如果创建优惠券页面选择的优惠券编码在优惠券数组中可以找到
                    if (val == _this.mapCouponArray[i].coupon_mode_code) {
                        // 获取优惠券使用时间
                        _this.mapCouponDataDisplay.time = [
                            _this.mapCouponArray[i].start_time.YmdHis,
                            _this.mapCouponArray[i].end_time.YmdHis
                        ];
                        _this.mapCouponDataDisplay.max_hold_count = _this.mapCouponArray[i].max_hold_count;
                        _this.mapCouponDataDisplay.max_count = _this.mapCouponArray[i].max_count;
                        // console.log(_this.mapCouponDataDisplay, '_this.mapCouponDataDisplay展示数据');

                        break;
                    }
                }
            }
        },
        computingTime() {
            var date = new Date(); //当前时间
            var hours = date.getHours(); //当前小时
            var minute = date.getMinutes();
            var second = date.getSeconds();
            var day = date.getDate(); //当前天 也就是今天是几号
            var getTimeVal = ''; //时间控件上不可选择的日期
            var orderTime = '';
            // _this.submit_data.order_time = '2024-01-05 00:00:00'
            // console.log(_this.submit_data.order_time, '_this.submit_data.order_time');
            var selectDay = _this.submit_data.order_time.slice(8, 10); //点击时间控件上的日期后获取到的时间，截取出来今天是几号
            var orderHours = ''; //时间控件上的小时

            // console.log(day, 'day');
            if (selectDay > day + 1) {
                //时间选择器选择后天
                orderHours = '00';
                minute = '00';
                second = '00';
                _this.defaultTime = '00:00:00';
            } else if (selectDay > day) {
                //时间选择器选择的天是明天，比如今天18号，选择时间为19号
                if (Number(hours) + 2 > 24) {
                    orderHours = '0' + String(Number(hours) + 2 - 24);
                    _this.defaultTime = 'orderHours:00:00';
                } else {
                    orderHours = '00';
                    minute = '00';
                    second = '00';
                    _this.defaultTime = '00:00:00';
                }
            } else {
                getTimeVal = Date.now() - 3600 * 1000 * 24; //今天及未来天可选
                //时间选择器选择今天
                // var orderHours = Number(hours) + 2;
                if (Number(hours) + 2 > 24) {
                    //2小时候后时间为明天了
                    getTimeVal = Date.now(); //今天不可选，明天以后可选
                    orderHours = '0' + String(Number(hours) + 2 - 24);
                    _this.defaultTime = 'orderHours:00:00';
                } else {
                    //两小时后以后还是今天
                    // 如果选择今天
                    if (selectDay == day) {
                        getTimeVal = Date.now() - 3600 * 1000 * 24; //今天及未来天可选
                        orderHours = Number(hours) + 2; //只能选择此刻2小时以后的时间
                        _this.defaultTime = 'orderHours:00:00';
                    } else {
                        //如果选择明天
                        orderHours = '00';
                        minute = '00';
                        second = '00';
                        _this.defaultTime = '00:00:00';
                        getTimeVal = Date.now(); //今天不可选，明天以后可选
                    }
                }
            }
            orderTime = `${orderHours}:${minute}:${second} - 23:59:59`;

            _this.pickerOptions1.selectableRange = orderTime;
            // console.log(_this.pickerOptions1.selectableRange, '_this.pickerOptions1.selectableRange');

            return getTimeVal;
        },
        changeTime() {
            // console.log('选择预约时间');

            _this.computingTime();
        },

        redChange() {
            if (_this.redMoneyType == '1') {
                // 记录发放红包定位
                _this.redMoney.lng = contextMenuPositon.lng;
                _this.redMoney.lat = contextMenuPositon.lat;

                // _this.addRedMoney(contextMenuPositon.lng, contextMenuPositon.lat);
                _this.redTitle = '红包位置：创建的起点';

                _this.beforeAddRedMoney(contextMenuPositon.lng, contextMenuPositon.lat);
            } else {
                if (redMarker) {
                    map.remove(redMarker);
                }
                _this.redTitle = '随机红包位置随机';
                _this.beforeAddRedMoneySj();
            }
        },
        // 点击确认发放按钮 发放优惠券
        grantyCoupon() {
            // console.log('点击确认发放按钮');
            _this.coupon_loading = true; // 发放后按钮loading
            if (_this.mapCouponData.coupon_mode_code == '') {
                this.$message.error('请选择优惠券');
                _this.coupon_loading = false;
                return;
            }
            var reg = /^-?\d+$/;

            if (!reg.test(_this.mapCouponData.grant_num)) {
                this.$message.error('发放数量为大于0的整数');
                _this.coupon_loading = false;
                return;
            }
            if (_this.mapCouponData.grant_num > _this.mapCouponDataDisplay.surplus_num) {
                this.$message.error('发放数量应小于最大发放数');
                _this.coupon_loading = false;

                return;
            }

            // _this.mapCouponData.lng = contextMenuPositon.lng;
            // _this.mapCouponData.lat = contextMenuPositon.lat;

            // console.log(contextMenuPositon, 'contextMenuPositon');

            _this.addMapCoupon(); // 发放优惠券接口
            _this.coupon_loading = false;
        },
        //发放红包 确认发放按钮方法
        grantRedMoney() {
            // console.log('发放红包确认发放方法');
            _this.grant_loading = true;
            var reg = /^-?\d+$/;
            if (_this.redMoneyType == '1') {
                if (_this.redMoney.num == '' || !reg.test(_this.redMoney.num) || _this.redMoney.num < 1) {
                    this.$message.error('红包个数为大于0的整数');

                    _this.grant_loading = false;
                    return;
                } else if (_this.redMoney.price == '' || _this.redMoney.price < 1) {
                    this.$message.error('红包金额应大于0');
                    _this.grant_loading = false;
                    return;
                } else if (
                    _this.redMoney.distance == '' ||
                    _this.redMoney.distance > 10000 ||
                    _this.redMoney.distance < 1 ||
                    !reg.test(_this.redMoney.distance)
                ) {
                    this.$message.error('领取距离为1-10000之间的整数数字');
                    _this.grant_loading = false;
                    return;
                }

                var searchDriverData = {
                    ws_mode: 'adminPositioningRewardControl',
                    lng: _this.redMoney.lng,
                    lat: _this.redMoney.lat,
                    num: _this.redMoney.num,
                    price: _this.redMoney.price,
                    distance: _this.redMoney.distance
                };
            } else {
                if (_this.redMoneySj.position_num == '' || !reg.test(_this.redMoneySj.position_num) || _this.redMoneySj.position_num < 1) {
                    this.$message.error('红包个数为大于0的整数');

                    _this.grant_loading = false;
                    return;
                } else if (_this.redMoneySj.price == '' || _this.redMoneySj.price < 1) {
                    this.$message.error('红包金额应大于0');
                    _this.grant_loading = false;
                    return;
                } else if (
                    _this.redMoneySj.distance == '' ||
                    _this.redMoneySj.distance > 10000 ||
                    _this.redMoneySj.distance < 1 ||
                    !reg.test(_this.redMoneySj.distance)
                ) {
                    this.$message.error('领取距离为1-10000之间的整数数字');
                    _this.grant_loading = false;
                    return;
                } else if (_this.redMoneySj.num == '' || !reg.test(_this.redMoneySj.num) || _this.redMoneySj.num < 1) {
                    this.$message.error('领取次数为大于0的整数');
                    _this.grant_loading = false;
                    return;
                }
                var searchDriverData = {
                    ws_mode: 'adminRandomRewardControl',
                    position_num: _this.redMoneySj.position_num,
                    price: _this.redMoneySj.price,
                    distance: _this.redMoneySj.distance,
                    num: _this.redMoneySj.num
                };
            }
            // console.log(searchDriverData, 'searchDriverData==================================================');

            // 发送数据发放红包
            _this.global.ws.send(JSON.stringify(searchDriverData));
            _this.isShowValue = false;

            _this.redMoneyType = '1';
            _this.redTitle = '红包位置：创建的起点';
            _this.grant_loading = false;
            //定点红包数据
            _this.redMoney = {
                price: '',
                num: '',
                distance: '',
                lng: '',
                lat: ''
            };
            //随机红包数据
            _this.redMoneySj = {
                price: '',
                num: '',
                distance: '',
                position_num: ''
            };
        },

        // 待派单一键AI方法
        addOrderToAI(val) {
            var sendData = {
                ws_mode: 'adminHelpSend',
                order_code: val.order_code,
                driver_code_array: '',
                remarks: _this.submit_data.remarks,
                ai_find_radius: _this.slider_km,
                ai_num: _this.matching.radius_slider_num
            };

            // console.log(sendData, 'sendData待派单一键AI方法');

            // 发送数据
            _this.global.ws.send(JSON.stringify(sendData));
        },

        // 取消协助指派
        transferOrderCancel() {
            // 清空司机数据
            _this.rightToptableData = [];
            // 清空地图上所有覆盖物
            _this.clearMap();

            _this.submit_data.start_name = '';
            _this.submit_data.start_coordinate = '';

            _this.submit_data.end_name = '';
            _this.submit_data.end_coordinate = '';

            _this.submit_data.order_code = '';
            // _this.submit_data.order_mode_code = '';

            _this.submit_data.consumer_phone = '';
            _this.submit_data.consumer_name = '';

            _this.main_right_show = false;
            _this.consumer_phone = false;

            _this.distributeLeaflets_flag = false;
            _this.submit_data.type = '0';
            _this.submit_data.vin_no = '';
            _this.submit_data.order_time = '';
            _this.submit_data.plate = '';
            _this.submit_data.get_phone = '';
        },

        // 去销单
        toSales(code) {
            // console.log(code,'code')
            let routeData = this.$router.resolve({
                path: '/substituteDrivingOrder',
                query: {
                    billno: code
                }
            });

            window.open(routeData.href, '_blank');
        },

        // 去销单并重新指派
        salesAndToDistributeLeaflets(val) {
            // 添加起点标记
            if (val.start_coordinate) {
                _this.startMark(val.start_coordinate.lng, val.start_coordinate.lat);
            }

            // 添加终点标记
            if (val.end_coordinate) {
                _this.endMark(val.end_coordinate.lng, val.end_coordinate.lat);
            }

            _this.submit_data.start_name = val.start_name;
            _this.submit_data.end_name = val.end_name;
            // _this.submit_data.order_code = val.order_code;
            _this.submit_data.order_mode_code = val.order_mode_code;

            // _this.endName(val.end_coordinate);
            _this.submit_data.consumer_phone = val.consumer_phone;
            _this.submit_data.consumer_name = val.consumer_name;
            _this.slider_km = 4;
            _this.main_right_show = true;

            _this.consumerPhone(_this.submit_data.consumer_phone);

            var sendData = {
                ws_mode: 'adminCancel',
                // order_code: _this.submit_data.order_code,
                order_mode_code: _this.submit_data.order_mode_code,
                consumer_duty_cancel_point: '0',
                driver_duty_cancel_point: '0',
                consumer_duty_cancel_amount: '0',
                remarks: ''
            };

            // 发送数据
            _this.global.ws.send(JSON.stringify(sendData));
        },

        // 协助指派方法
        toTransferOrder() {
            // console.log('协助指派');
            var sendData = {
                ws_mode: 'adminHelpSend',
                order_code: _this.submit_data.order_code,
                order_mode_code: _this.submit_data.order_mode_code,
                driver_code_array: _this.submit_data.driver_code,
                remarks: _this.submit_data.remarks,
                ai_find_radius: _this.slider_km,
                ai_num: _this.matching.radius_slider_num
            };
            // console.log(sendData, 'sendData协助指派方法');


            // 发送数据
            _this.global.ws.send(JSON.stringify(sendData));
        },

        localSocket() {
            if ('WebSocket' in window) {
                // console.log('您的浏览器支持 WebSocket!');

                _this.ws = new WebSocket(_this.$getSocketUrl());

                _this.global.setWs(_this.ws);

                _this.ws.onopen = _this.webSocketOnOpen;

                _this.ws.onerror = _this.webSocketOnError;

                _this.ws.onclose = _this.webSocketOnClose;
            } else {
                // 浏览器不支持 WebSocket
                // console.log('您的浏览器不支持 WebSocket!');
            }
        },

        // 建立连接成功后的状态
        webSocketOnOpen() {
            // 发送数据
            // _this.global.ws.send(JSON.stringify(_this.sendData));
        },

        // 关闭连接
        webSocketOnClose() {
            // console.log('socket已关闭');

            // console.log(_this.firstlog);

            if (_this.firstlog && _this.socket_relink_num < 10) {
                setTimeout(() => {
                    _this.socket_relink_num += 1;
                    _this.onSocket();
                }, 2000);
            } else if (_this.socket_relink_num >= 10) {
                _this.$notify({
                    message: 'WebSocket链接失败,请刷新浏览器重试',
                    duration: 0,
                    type: 'warning',
                    offset: 80
                });
            }
        },

        //连接失败的事件
        webSocketOnError(res) {},

        // 接收Socket方法
        onSocket() {
            // var token = localStorage.getItem(config.localStorage_token_name);
            // // 哈希值
            // var hash_key = this.$hash_key();
            // _this.sendData.ws_mode = 'link';
            // _this.sendData.token = token;
            // _this.sendData.hash_key = hash_key;
            // 建立Socket连接
            _this.localSocket();
            // 长连接接收内容
            // console.log(_this.global,'_this.global');
            _this.global.ws.onmessage = function (res) {
                var resData = JSON.parse(res.data);

                console.log(resData,'resData======');
                _this.$driverState(resData);
                // console.log(resData.identification == 'adminPositioningRewardControl' && resData.header == 'error');
                if (resData.identification == 'link' && resData.header == 'success') {
                    // console.log(resData);
                    //连接成功后初始化链接次数------------每次断开有10次重连机会
                    _this.socket_relink_num = 0;
                    var data = {
                        server_status_0: 1,
                        server_status_1: 0,
                        server_status_2: 0,
                        server_status_3: 0,
                        server_status_4: 0,
                        server_status_5: 0,
                        server_status_6: 0,
                        switch: 1,
                        status: 1 // 1只返回听单中司机，2所有状态司机都返回
                    };
                    var sendData = {
                        ws_mode: 'driverControl',
                        driver_control_synchronization: JSON.stringify(data)
                    };
                    _this.global.ws.send(JSON.stringify(sendData));
                    // 获取现在存在红包
                    var sendData = {
                        ws_mode: 'adminAllPositioningReward'
                    };
                    _this.global.ws.send(JSON.stringify(sendData));

                    _this.$sendPing(); // socket每10秒发送一次心跳
                } else if (resData.header == 'error') {
                    // 接收到弹窗信息
                    _this.$message.error(resData.msg);
                } else if (resData.identification == 'link' && resData.header == 'logout') {
                    // 接收token失效
                    bus.$emit('firstlog', false);
                } else if (resData.identification == 'positioning_reward' && resData.header == 'success') {
                    // 接口返回红包信息后创建红包，这样删除红包的时候能拿到红包信息里面的编码
                    _this.addRedMoney(resData.data.lng, resData.data.lat, resData.data.positioning_reward_code);
                    _this.grant_loading = false;
                } else if (resData.identification == 'adminPositioningRewardControl' && resData.header == 'success') {
                    // 创建红包成功
                    _this.$message.success(resData.msg);
                    _this.grant_loading = false;
                    _this.redMoneyCancel();
                } else if (resData.identification == 'adminPositioningRewardControl' && resData.header == 'fail') {
                    // 创建红包失败
                    _this.$message.error(resData.msg);
                    _this.grant_loading = false;
                } else if (resData.identification == 'driver_control' && resData.header == 'success') {
                    // 如果接收到司机数据

                    // console.log(resData);

                    // 如果是听单中状态的司机则添加司机标签，否则不处理
                    if (resData.data.status == '1') {
                        // 添加司机标签
                        _this.addDriver(
                            resData.data.driver_code,
                            resData.data.real_name,
                            resData.data.lng,
                            resData.data.lat,
                            resData.data.status,
                            resData.data.dan
                        );
                    } else {
                        if (typeof _this.driver[resData.data.driver_code] !== 'undefined') {
                            // 清除对应的司机标签
                            _this.driver[resData.data.driver_code].setMap(null);

                            // 将对象中对应的driver_code对象删除
                            delete _this.driver[resData.data.driver_code];
                        }
                    }
                } else if (resData.identification == 'driver_listen_cut' && resData.header == 'success') {
                    // 如果接收到司机cut数据 司机取消听单

                    if (typeof _this.driver[resData.data.driver_code] !== 'undefined') {
                        // 清除对应的司机标签
                        _this.driver[resData.data.driver_code].setMap(null);

                        // 将对象中对应的driver_code对象删除
                        delete _this.driver[resData.data.driver_code];
                    }
                } else if (resData.identification == 'del_positioning_reward' && resData.header == 'success') {
                    // 如果接删除红包成功

                    if (typeof _this.redMarker[resData.data] !== 'undefined') {
                        // 清除对应的司机标签
                        _this.redMarker[resData.data].setMap(null);

                        // 将对象中对应的driver_code对象删除
                        delete _this.redMarker[resData.data];
                        _this.grant_loading = false;

                        _this.redMoneyDetailsCancel();
                    }
                } else if (resData.identification == 'driver_offline' && resData.header == 'success') {
                    // 如果接收到司机下线数据

                    if (typeof _this.driver[resData.data.driver_code] !== 'undefined') {
                        // 清除对应的司机标签
                        _this.driver[resData.data.driver_code].setMap(null);

                        // 将对象中对应的driver_code对象删除
                        delete _this.driver[resData.data.driver_code];
                    }
                } else if (resData.identification == 'adminNewOrder' && resData.header == 'success') {
                    // console.log(resData);

                    // 接收到下单成功数据
                    _this.addOrderTip_isShow = !_this.addOrderTip_isShow;
                    _this.addOrderTip_data = resData.data;
                    _this.addOrderTip_type = 'success';

                    // 清空路线规划
                    if (driving) {
                        //调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
                        driving.clear();
                        _this.distance = '0';
                        _this.estimate = '0';
                        // 清空预估价格
                        _this.price = '0';
                    }

                    // 清空submit_data的数据
                    _this.submit_data.driver_code = '';
                    _this.submit_data.start_name = '';
                    _this.submit_data.start_coordinate = '';
                    _this.submit_data.end_name = '';
                    _this.submit_data.end_coordinate = '';
                    _this.submit_data.consumer_name = '';
                    _this.submit_data.consumer_phone = '';
                    // _this.submit_data.order_mode_code = '';
                    _this.submit_data.order_code = '';
                    _this.submit_data.order_time = '';
                    _this.submit_data.driver_number = '';
                    _this.submit_data.remarks = '';
                    _this.submit_data.order_tag_num = '1';
                    _this.submit_data.type = '0';
                    _this.submit_data.vin_no = '';

                    _this.submit_data.plate = '';
                    _this.submit_data.get_phone = '';

                    _this.rightToptableData = [];

                    // 隐藏右侧推荐服务人员组件
                    _this.main_right_show = false;
                    _this.consumer_phone = false;

                    _this.consumer_data = [];

                    _this.addOrderBtn = true;

                    _this.clearMap();
                } else if (resData.identification == 'adminNewOrder' && resData.header != 'success') {
                    // 接收到下单失败数据
                    // console.log(resData);

                    _this.tipModel_isShow = !_this.tipModel_isShow;
                    _this.tipModel_data = resData.msg;
                    _this.tipModel_type = 'error';

                    _this.rightToptableData = [];

                    _this.addOrderBtn = true;
                } else if (resData.identification == 'nearbyDriver' && resData.header == 'success') {
                    // 搜索司机的数据
                    // console.log(resData, '---000');
                    _this.rightToptableData = resData.data.result;
                    //  console.log(_this.rightToptableData,'_this.rightToptableData=======');
                    _this.loading = false;
                } else if (resData.identification == 'nearbyDriver' && resData.header == 'fail') {
                    // 搜索司机的数据
                    // console.log(resData);
                    _this.rightToptableData = [];

                    _this.loading = false;
                } else if (resData.identification == 'nearbyDriver' && resData.header == 'error') {
                    // 搜索司机的数据
                    // console.log(resData);
                    _this.rightToptableData = [];
                    _this.$message.error(resData.msg);
                    _this.loading = false;
                } else if (resData.identification == 'need_driver' && resData.header == 'success') {
                    // 接收到订单数据，并且为success

                    // console.log(resData,'协助指派订单数据');

                    // 遍历table数组，如果有order_code一致的数据，则删除这一条数据
                    for (let i = 0; i < _this.need_driver.length; i++) {
                        if (_this.need_driver[i].order_code == resData.data.order_code) {
                            _this.need_driver.splice(i, 1);
                        }
                        // _this.need_driver[i].data.order_code == resData.data.order_code;
                    }
                } else if (resData.identification == 'need_driver' && resData.header == 'wait') {
                    // 接收到订单数据，需要指派司机

                    // console.log(resData, '接收到订单数据，需要指派司机');

                    for (let i = 0; i < _this.need_driver.length; i++) {
                        if (_this.need_driver[i].order_code == resData.data.order_code) {
                            return;
                        }
                    }

                    // table数组中添加数据
                    _this.need_driver.push(resData.data);
                    // console.log(_this.need_driver,'_this.need_driver');
                } else if (resData.identification == 'adminHelpSend' && resData.header == 'success') {
                    // 搜索转派成功的数据
                    // console.log(resData);
                    _this.tipModel_isShow = !_this.tipModel_isShow;
                    _this.tipModel_data = resData.msg;
                    _this.tipModel_type = 'success';
                    _this.distributeLeaflets_flag = false;

                    // 清空路线规划
                    if (driving) {
                        //调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
                        driving.clear();
                        _this.distance = '0';
                        _this.estimate = '0';
                        // 清空预估价格
                        _this.price = '0';
                    }

                    // 清空submit_data的数据
                    _this.submit_data.driver_code = '';
                    _this.submit_data.start_name = '';
                    _this.submit_data.start_coordinate = '';
                    _this.submit_data.end_name = '';
                    _this.submit_data.end_coordinate = '';
                    _this.submit_data.consumer_name = '';
                    _this.submit_data.consumer_phone = '';
                    // _this.submit_data.order_mode_code = '';
                    _this.submit_data.order_code = '';

                    _this.submit_data.order_time = '';
                    _this.submit_data.driver_number = '';
                    _this.submit_data.remarks = '';
                    _this.submit_data.order_tag_num = '1';
                    _this.submit_data.type = '0';
                    _this.submit_data.vin_no = '';
                    _this.submit_data.plate = '';
                    _this.submit_data.get_phone = '';

                    _this.rightToptableData = [];

                    // 隐藏右侧推荐服务人员组件
                    _this.main_right_show = false;
                    _this.consumer_phone = false;

                    _this.consumer_data = [];

                    _this.clearMap();
                } else if (resData.identification == 'adminHelpSend' && resData.header !== 'success') {
                    // 搜索转派失败的数据
                    // console.log(resData);
                    _this.$message.error(resData.msg);
                } else if (resData.identification == 'adminCancel' && resData.header == 'success') {
                    // 后台销单成功信息
                    // console.log(resData);
                    _this.tipModel_isShow = !_this.tipModel_isShow;
                    _this.tipModel_data = resData.msg;
                    _this.tipModel_type = 'success';

                    for (let i = 0; i < _this.need_driver.length; i++) {
                        if (_this.need_driver[i].order_code == resData.data.order_code) {
                            _this.need_driver.splice(i, 1);
                        }
                        // _this.need_driver[i].data.order_code == resData.data.order_code;
                    }

                    _this.load = true;
                } else if (resData.identification == 'adminCancel' && resData.header == 'error') {
                    _this.tipModel_isShow = !_this.tipModel_isShow;
                    _this.tipModel_data = resData.msg;
                    _this.tipModel_type = 'error';
                }
            };
        },

        toOrderList(code) {
            // 路由传参
            let routeData = this.$router.resolve({
                path: '/substituteDrivingOrder',
                query: {
                    billno: code
                }
            });

            window.open(routeData.href, '_blank');
        },

        actualBtn() {
            _this.actual = !_this.actual;
            _this.searchDriver(_this.search_driver_data.lng, _this.search_driver_data.lat, _this.slider_km);
        },

        // 推荐服务人员表格鼠标移入事件
        mainRightTableEnter() {
            _this.appointment_show = true;
        },

        // 推荐服务人员表格鼠标离开事件
        mainRightTableLeave() {
            _this.appointment_show = false;
        },

        // 搜索司机数据顺序
        rightTopSearchBtn(val) {
            _this.right_top_search_btn = val;

            localStorage.setItem('order_by', val);

            _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km);
        },

        // 协助指派方法
        distributeLeaflets(val) {
            // console.log(val, 'val000000');
            // 添加起点标记
            if (val.start_coordinate) {
                _this.startMark(val.start_coordinate.lng, val.start_coordinate.lat);
            }

            // 添加终点标记
            if (val.end_coordinate) {
                _this.endMark(val.end_coordinate.lng, val.end_coordinate.lat);
                _this.estimatedPrice(); // 有终点才能获取预估价
                _this.drivingLine(); // 有终点才能绘制驾车路线
            }

            _this.submit_data.start_name = val.start_name;
            _this.submit_data.end_name = val.end_name;
            _this.submit_data.order_code = val.order_code;
            _this.submit_data.order_mode_code = val.order_mode.order_mode_code;

            // _this.endName(val.end_coordinate);
            _this.submit_data.consumer_phone = val.consumer_phone;
            _this.submit_data.consumer_name = val.consumer_name;

            _this.slider_km = 4;
            _this.main_right_show = true;

            _this.consumerPhone(_this.submit_data.consumer_phone);



            _this.distributeLeaflets_flag = true;
        },

        // 根据用户历史记录确定起点
        thisRouteStart(start_coordinate, start_name) {
            if (start_coordinate) {
                _this.startMark(start_coordinate.lng, start_coordinate.lat);
            }
            _this.submit_data.start_name = start_name;

            // 如果起点和终点都存在，则规划驾车导航
            if (_this.submit_data.start_coordinate != '' && _this.submit_data.end_coordinate != '') {
                // 规划驾车导航
                _this.drivingLine();
            }
        },

        // 根据用户历史记录确定终点
        thisRouteEnd(end_coordinate, end_name) {
            if (end_coordinate) {
                _this.endMark(end_coordinate.lng, end_coordinate.lat);
            }

            _this.submit_data.end_name = end_name;

            // 如果起点和终点都存在，则规划驾车导航
            if (_this.submit_data.start_coordinate != '' && _this.submit_data.end_coordinate != '') {
                // 规划驾车导航
                _this.drivingLine();
            }
        },
        orderModeChange(code) {
            // console.log(code, '---------');
            for (let i = 0; i < _this.value_order_array.length; i++) {
                if (_this.value_order_array[i].order_mode.order_mode_code == code) {
                    _this.strategy = _this.value_order_array[i].strategy;
                    // console.log(_this.strategy, '_this.strategy');
                }
            }
            if (_this.search_driver_data.lng != '' && _this.search_driver_data.lat != '') {
                _this.searchDriver(_this.search_driver_data.lng, _this.search_driver_data.lat, _this.slider_km);
            }

            if (_this.submit_data.start_name != '' && _this.submit_data.end_name != '') {
                // 规划驾车导航
                _this.drivingLine();
            }
            _this.estimatedPrice();
        },
        // 获取预估价格
        estimatedPrice() {
            if (
                _this.submit_data.order_mode_code != '' &&
                _this.submit_data.start_coordinate != '' &&
                _this.submit_data.end_coordinate != ''
            ) {
                axios.defaults.baseURL = config.axios_normalURL; //请求base url

                _this
                    .$post('/order/estimatedPrice', {
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_coordinate: _this.submit_data.end_coordinate
                    })
                    .then((res) => {
                        _this.price = res.data.amount;
                        _this.distance = res.data.distance;
                    })
                    .catch((err) => {});
                axios.defaults.baseURL = config.axios_baseURL; //请求base url
            } else {
                _this.price = '0';
            }
        },

        // 获取用户信息方法
        consumerPhone(val) {
            if (_this.consumer_phone_type == '手机') {
                if (val.length == 11 && val) {
                    _this.getConsumerDetails();
                } else {
                    _this.consumer_phone = false;
                }
            } else if (_this.consumer_phone_type == '固话') {
                if (val.length == 13 && val) {
                    _this.getConsumerDetails();
                } else {
                    _this.consumer_phone = false;
                }
            }
        },

        getConsumerDetails() {
            _this.consumer_data = [];
            _this.order_ongoing = [];

            axios.defaults.baseURL = config.axios_normalURL;

            // 获取用户信息
            _this
                .$post('/order/consumerInfo', {
                    phone: _this.submit_data.consumer_phone
                })
                .then((res) => {
                    _this.consumer_data.push(res.data);
                    //  console.log(_this.consumer_data,'_this.consumer_data33');
                    _this.consumer_phone = true;
                    _this.submit_data.consumer_name = res.data.name;

                    if (res.data.order_ongoing_details.length != 0) {
                        _this.order_ongoing.push(res.data.order_ongoing_details);
                        // console.log(_this.order_ongoing,'_this.order_ongoing');

                    }

                    if (_this.submit_data.assign_mode != 'ai') {
                        _this.main_right_show = true;
                    }
                })
                .catch((err) => {});

            axios.defaults.baseURL = config.axios_baseURL;
        },

        // 选择司机触发
        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }

            _this.submit_data.driver_number = datalist.length;

            // 如果选择司机超过了限定人数
            if (_this.submit_data.driver_number > _this.driver_number) {
                _this.submit_data.driver_number = 0;
                _this.$message.error('司机超过限定人数');
                // 清空选择
                _this.$refs.multipleTable.clearSelection();
                _this.submit_data.driver_code = '';
            }

            _this.submit_data.driver_code = JSON.stringify(datalist);
        },

        // 创建订单按钮
        addOrderSubmit() {
            _this.start_panel_innerHtml = [];
            _this.end_panel_innerHtml = [];

            if (_this.submit_data.order_mode_code == '') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '未选择订单模式',
                    duration: 0
                });
                return;
            }
            if (_this.submit_data.start_name == '') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '未选择起点',
                    duration: 0
                });
                return;
            }
            if (_this.submit_data.start_coordinate == '') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '未选择起点',
                    duration: 0
                });
                return;
            }
            if (_this.submit_data.consumer_name == '') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '未填写用户姓名',
                    duration: 0
                });
                return;
            }
            if (_this.submit_data.consumer_phone == '') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '未填写用户电话号',
                    duration: 0
                });
                return;
            }

            if (_this.consumer_phone_type == '手机') {
                if (_this.submit_data.consumer_phone.length != 11) {
                    if (msgDig) {
                        msgDig.close();
                    }

                    msgDig = _this.$message.error({
                        showClose: true,
                        message: '用户手机号码必须为11位',
                        duration: 0
                    });
                    return;
                }
            }

            if (_this.consumer_phone_type == '固话') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '固话派单功能暂未开放！！！',
                    duration: 0
                });

                // if (_this.submit_data.consumer_phone.length != 13) {
                //
                //   if (msgDig) {
                //     msgDig.close();
                //   }
                //
                //   msgDig = _this.$message.error({
                //     showClose: true,
                //     message: '用户固话必须为13位,如:0431-XXXXXXXX',
                //     duration: 0
                //   });
                //
                //
                //   return;
                //
                // }
            }

            // if (_this.submit_data.assign_mode != 'ai' && (_this.submit_data.driver_code == '' || _this.submit_data
            //     .driver_code.length == 0 || _this.submit_data.driver_code == '[]')) {
            //     if (msgDig) {
            //         msgDig.close();
            //     }
            //
            //     msgDig = _this.$message.error({
            //         showClose: true,
            //         message: '未选择司机',
            //         duration: 0
            //     });
            //     return;
            //
            // }

            if (_this.submit_data.remarks.length > 200) {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '订单备注不能超过200字',
                    duration: 0
                });
                return;
            }
            if (_this.submit_data.type == '' && _this.submit_data.order_time == '') {
                if (msgDig) {
                    msgDig.close();
                }

                msgDig = _this.$message.error({
                    showClose: true,
                    message: '请选择预约时间',
                    duration: 0
                });
                return;
            }
            if (_this.submit_data.type != '') {
                _this.submit_data.order_time = '';
            }
            if (_this.submit_data.type == '1') {
                if (_this.submit_data.get_phone == '') {
                    if (msgDig) {
                        msgDig.close();
                    }

                    msgDig = _this.$message.error({
                        showClose: true,
                        message: '请填写接车人电话',
                        duration: 0
                    });
                    return;
                }
            }

            // if (_this.submit_data.assign_mode == 'assign' && _this.submit_data.order_tag_num > JSON.parse(_this.submit_data
            //     .driver_code).length) {
            //

            //     if (msgDig) {
            //         msgDig.close();
            //     }
            //
            //     msgDig = _this.$message.error({
            //         showClose: true,
            //         message: '选择司机数量不满足需求',
            //         duration: 0
            //     });
            //     return;
            // }

            _this.addOrderBtn = false;

            // 4秒后按钮变回可点状态
            setTimeout(() => {
                _this.addOrderBtn = true;
            }, 4000);

            // 如果用户当前存在进行中的订单
            if (_this.order_ongoing.length != 0) {
                _this
                    .$confirm(
                        ' <p>当前用户存在<span style="font-weight: bold;color: red">' +
                            _this.order_ongoing[0].status.alias +
                            '</span>订单,是否继续派单</p>',
                        '提示',
                        {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定',

                            cancelButtonText: '取消',

                            type: 'warning'
                        }
                    )
                    .then(() => {
                        _this.addOrderFun();
                    })
                    .catch(() => {
                        _this.addOrderBtn = true;
                        _this.$message({
                            message: '已取消派单',
                            duration: 1500
                        });
                    });
            } else {
                _this.addOrderFun();
            }
        },
        async isManChange(){
            await this.orderModeLists();
            this.estimatedPrice();
        },
        // 创建订单方法
        addOrderFun() {
            // console.log(_this.submit_data, '_this.submit_data======');
            if (_this.submit_data.assign_mode == 'ai') {
                //指派模式为AI派单时发送的数据
                if (_this.submit_data.type == '1') {
                    var sendData = {
                        ws_mode: 'adminNewOrder',
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_name: _this.submit_data.start_name,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_name: _this.submit_data.end_name,
                        end_coordinate: _this.submit_data.end_coordinate,
                        name: _this.submit_data.consumer_name,
                        phone: _this.submit_data.consumer_phone,
                        order_tag_num: _this.submit_data.order_tag_num,
                        driver_code_array: _this.submit_data.driver_code,
                        appointment_time: _this.submit_data.order_time,
                        remarks: _this.submit_data.remarks,
                        assign_mode: _this.submit_data.assign_mode,
                        ai_find_radius: _this.slider_km,
                        is_man:this.is_man,
                        ai_num: _this.matching.radius_slider_num,
                        type: _this.submit_data.type,
                        vin_no: _this.submit_data.vin_no,
                        plate: _this.submit_data.plate,
                        get_phone: _this.submit_data.get_phone
                    };
                } else {
                    var sendData = {
                        ws_mode: 'adminNewOrder',
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_name: _this.submit_data.start_name,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_name: _this.submit_data.end_name,
                        end_coordinate: _this.submit_data.end_coordinate,
                        name: _this.submit_data.consumer_name,
                        phone: _this.submit_data.consumer_phone,
                        order_tag_num: _this.submit_data.order_tag_num,
                        driver_code_array: _this.submit_data.driver_code,
                        appointment_time: _this.submit_data.order_time,
                        remarks: _this.submit_data.remarks,
                        assign_mode: _this.submit_data.assign_mode,
                        ai_find_radius: _this.slider_km,
                        ai_num: _this.matching.radius_slider_num,
                        type: _this.submit_data.type,
                        vin_no: '',
                        plate: '',
                        get_phone: ''
                    };
                }
            } else if (_this.submit_data.assign_mode == 'assign') {
                //指派模式为非AI派单时发送的数据

                if (_this.submit_data.type == '1') {
                    var sendData = {
                        ws_mode: 'adminNewOrder',
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_name: _this.submit_data.start_name,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_name: _this.submit_data.end_name,
                        end_coordinate: _this.submit_data.end_coordinate,
                        name: _this.submit_data.consumer_name,
                        phone: _this.submit_data.consumer_phone,
                        order_tag_num: _this.submit_data.order_tag_num,
                        driver_code_array: _this.submit_data.driver_code,
                        appointment_time: _this.submit_data.order_time,
                        remarks: _this.submit_data.remarks,
                        assign_mode: _this.submit_data.assign_mode,
                        type: _this.submit_data.type,
                        vin_no: _this.submit_data.vin_no,
                        plate: _this.submit_data.plate,
                        get_phone: _this.submit_data.get_phone
                    };
                } else {
                    var sendData = {
                        ws_mode: 'adminNewOrder',
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_name: _this.submit_data.start_name,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_name: _this.submit_data.end_name,
                        end_coordinate: _this.submit_data.end_coordinate,
                        name: _this.submit_data.consumer_name,
                        phone: _this.submit_data.consumer_phone,
                        order_tag_num: _this.submit_data.order_tag_num,
                        driver_code_array: _this.submit_data.driver_code,
                        appointment_time: _this.submit_data.order_time,
                        remarks: _this.submit_data.remarks,
                        assign_mode: _this.submit_data.assign_mode,
                        type: _this.submit_data.type,
                        vin_no: '',
                        plate: '',
                        get_phone: ''
                    };
                }
            } else {
                //指派模式为非AI派单时发送的数据
                var sendData = {};
                if (_this.submit_data.type == '1') {
                    var sendData = {
                        ws_mode: 'adminNewOrder',
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_name: _this.submit_data.start_name,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_name: _this.submit_data.end_name,
                        end_coordinate: _this.submit_data.end_coordinate,
                        name: _this.submit_data.consumer_name,
                        phone: _this.submit_data.consumer_phone,
                        order_tag_num: _this.submit_data.order_tag_num,
                        driver_code_array: '',
                        appointment_time: _this.submit_data.order_time,
                        remarks: _this.submit_data.remarks,
                        assign_mode: 'assign',
                        type: _this.submit_data.type,
                        vin_no: _this.submit_data.vin_no,
                        plate: _this.submit_data.plate,
                        get_phone: _this.submit_data.get_phone
                    };
                } else {
                    var sendData = {
                        ws_mode: 'adminNewOrder',
                        order_mode_code: _this.submit_data.order_mode_code,
                        start_name: _this.submit_data.start_name,
                        start_coordinate: _this.submit_data.start_coordinate,
                        end_name: _this.submit_data.end_name,
                        end_coordinate: _this.submit_data.end_coordinate,
                        name: _this.submit_data.consumer_name,
                        phone: _this.submit_data.consumer_phone,
                        order_tag_num: _this.submit_data.order_tag_num,
                        driver_code_array: '',
                        appointment_time: _this.submit_data.order_time,
                        remarks: _this.submit_data.remarks,
                        assign_mode: 'assign',
                        type: _this.submit_data.type,
                        vin_no: '',
                        plate: '',
                        get_phone: ''
                    };
                }
            }

            // console.log(sendData, 'sendData0--');

            // 发送数据
            _this.global.ws.send(JSON.stringify(sendData));

            //  _this.orderModeLists();

        },

        // 清除地图方法
        clearMap() {
            // 清空路线规划
            if (driving) {
                //调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
                driving.clear();
                _this.distance = '0';
                _this.estimate = '0';
            }

            // 清除起点坐标
            if (startMarker) {
                map.remove(startMarker);
                _this.search_driver_data.lng = '';
                _this.search_driver_data.lat = '';
                _this.submit_data.start_coordinate = '';
                _this.submit_data.start_name = '';
            }

            if (circle) {
                map.remove(circle);
            }

            if (marker) {
                marker.setMap(null);
            }

            // 清除终点坐标
            if (endMarker) {
                map.remove(endMarker);
                _this.end.lng = '';
                _this.end.lat = '';
                _this.submit_data.end_coordinate = '';
                _this.submit_data.end_name = '';
            }

            _this.price = '0';
        },

        // 订单模式设为默认按钮
        toDefault() {
            // 将选中的订单模式存到缓存中,下次访问时设置成默认选项
            localStorage.setItem('order_mode', _this.submit_data.order_mode_code);
            _this.$message.success('已设为默认');
        },

        // 指派模式选中方法
        assignChange(val) {
            // console.log(val,'val===');
            localStorage.setItem('assign_mode', val);

            if (val == 'ai') {
                _this.main_right_show = false;
                _this.submit_data.driver_number = '';
            } else {
                _this.main_right_show = true;
            }
            // console.log(_this.submit_data.driver_number,'_this.submit_data.driver_number');
            _this.searchDriver(_this.search_driver_data.lng, _this.search_driver_data.lat, _this.slider_km);
        },

        beforeAddRedMoney(lng, lat) {
            if (redMarker) {
                map.remove(redMarker);
            }
            var redIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(26, 35),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                // 图标所用图片大小
                imageSize: new AMap.Size(26, 35),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(0, 0)
            });

            // 将 icon 传入 marker
            redMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                icon: redIcon,
                draggable: false,
                offset: new AMap.Pixel(-10, -15),
                zIndex: 999
            });

            map.add(redMarker);
            // 关闭红包详情
            _this.redMoneyDetailsCancel();

            // _this.addRedMoney(lng,lat)
        },
        beforeAddRedMoneySj() {
            // 关闭红包详情
            _this.redMoneyDetailsCancel();
        },
        //删除红包
        delRedMoney(code) {
            _this.grant_loading = true;
            var searchDriverData = {
                ws_mode: 'adminDelPositioningReward',
                positioning_reward_code: code
            };

            // 发送数据发放红包
            _this.global.ws.send(JSON.stringify(searchDriverData));
            _this.redMoneyDetailsCancel();
        },
        //删除优惠券
        deleteMapCoupon(code) {
            _this.coupon_loading = true;

            _this
                .$post('/map/deleteMapCoupon', { map_coupon_code: code })
                .then((res) => {
                    this.$message.success(res.msg);

                    // console.log(_this.couponMarker, '_this.couponMarker111');

                    if (_this.couponMarker) {
                        map.remove(_this.couponMarker);
                        // console.log(_this.couponMarker, '_this.couponMarker222');
                        _this.couponDetailas_show = false;
                        _this.coupon_loading = false;
                    }
                    _this.couponDetailsCancel();

                    // 删除后调优惠券详情接口重新在地图上渲染优惠券

                    _this.getMapCouponList(code);
                })
                .catch((err) => {});
        },

        // 关闭红包详情
        redMoneyDetailsCancel() {
            // console.log('关闭红包详情');
            _this.redMoneyDetailas = {
                distance: '',
                num: '',
                price: '',
                surplus_num: '',
                positioning_reward_code: ''
            };
            _this.RedMoneyDetailas_show = false;
        },
        // 关闭优惠券详情
        couponDetailsCancel() {
            _this.couponDetailas = {
                coupon_name: '',
                receive_num: '',
                surplus_num: '',

                map_coupon_code: ''
            };
            _this.couponDetailas_show = false;
        },
        //取消发放优惠券
        couponCancel() {
            _this.mapCouponData = {
                coupon_mode_code: '',
                grant_num: '',
                // distance: '',
                lng: '',
                lat: ''
            };
            _this.mapCouponDataDisplay = {
                surplus_num: '',
                time: '',
                max_hold_count: '',
                max_count: ''
            };
            _this.isShowValueY = false;
            // console.log(couponMarker, 'couponMarker取消发放');

            if (couponMarker) {
                // 如果点击标记存在，删除右键的时候添加的点标记

                map.remove(couponMarker);
            }
        },

        //取消发放红包
        redMoneyCancel() {
            _this.redMoney = {
                price: '',
                num: '',
                distance: '',
                lng: '',
                lat: ''
            };
            _this.redMoneySj = {
                price: '',
                num: '',
                distance: '',
                position_num: ''
            };
            _this.isShowValue = false;
            _this.redMoneyType = '1';
            _this.redTitle = '红包位置：创建的起点';

            map.remove(redMarker);
        },

        // 获取地图优惠券发放地点接口后，在地图上添加优惠券点标记
        addCouponMark(e) {
            var couponIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(60, 60),
                // 图标的取图地址

                image: require('@/assets/coupon.png'),
                // 图标所用图片大小
                imageSize: new AMap.Size(60, 60),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(-15, 5)
            });
            // 将 icon 传入 marker
            _this.couponMarker[e.map_coupon_code] = new AMap.Marker({
                position: new AMap.LngLat(e.lng, e.lat),
                icon: couponIcon,
                draggable: false,
                offset: new AMap.Pixel(-13, -30),
                zIndex: 999,
                clickable: true
            });
            map.add(_this.couponMarker[e.map_coupon_code]);

            // 优惠券图标点击事件
            var clickHandle = AMap.event.addListener(_this.couponMarker[e.map_coupon_code], 'click', function () {
                _this.getCouponDetailas(e);
            });
        },
        addRedMoney(lng, lat, positioning_reward_code) {
            // 如果红包的code码当前没有显示，则显示到地图
            if (typeof _this.redMarker[positioning_reward_code] == 'undefined') {
                var redIcon = new AMap.Icon({
                    // 图标尺寸
                    size: new AMap.Size(60, 60),
                    // 图标的取图地址
                    // image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                    image: require('../../../assets/red-money.png'),
                    // 图标所用图片大小
                    imageSize: new AMap.Size(60, 60),
                    // 图标取图偏移量
                    imageOffset: new AMap.Pixel(-15, 5)
                });
                // 将 icon 传入 marker
                _this.redMarker[positioning_reward_code] = new AMap.Marker({
                    position: new AMap.LngLat(lng, lat),
                    icon: redIcon,
                    draggable: false,
                    offset: new AMap.Pixel(-13, -30),
                    zIndex: 999,
                    clickable: true
                });
                map.add(_this.redMarker[positioning_reward_code]);

                // 红包图标点击事件
                var clickHandle = AMap.event.addListener(_this.redMarker[positioning_reward_code], 'click', function () {
                    _this.getRedMoneyDetailas(positioning_reward_code);
                });
            }
        },

        //查看红包详情
        getRedMoneyDetailas(code) {
            _this
                .$post('/driver/getPositioningRewardDetails', {
                    positioning_reward_code: code
                })
                .then((res) => {
                    _this.redMoneyDetailas.distance = res.data.distance;
                    _this.redMoneyDetailas.num = res.data.num;
                    _this.redMoneyDetailas.price = res.data.price;
                    _this.redMoneyDetailas.surplus_num = res.data.surplus_num;
                    _this.redMoneyDetailas.positioning_reward_code = res.data.positioning_reward_code;
                })
                .catch((err) => {});

            // 关闭创建红包开关??干啥用的
            // _this.redMoney.show = false;

            // 显示红包详情
            _this.RedMoneyDetailas_show = true;
        },

        //查看优惠券详情
        getCouponDetailas(e) {
            _this.couponDetailas.coupon_name = e.coupon_name;
            _this.couponDetailas.receive_num = e.receive_num;
            _this.couponDetailas.surplus_num = e.surplus_num;
            _this.couponDetailas.map_coupon_code = e.map_coupon_code;

            // 显示红包详情
            _this.couponDetailas_show = true;
        },

        // 创建起点点标记
        startMark(lng, lat) {
            if (startMarker) {
                map.remove(startMarker);
            }
            var lnglat = String(lng) + ',' + String(lat);
            _this.search_driver_data.lng = lng;
            _this.search_driver_data.lat = lat;
            _this.submit_data.start_coordinate = lnglat;
            // 添加起点标记
            // 创建一个 Icon
            var startIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(25, 34),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                // 图标所用图片大小
                imageSize: new AMap.Size(135, 40),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(-9, -3)
            });

            // 将 icon 传入 marker
            startMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                icon: startIcon,
                draggable: true,
                offset: new AMap.Pixel(-13, -30),
                zIndex: 999
            });

            map.add(startMarker);

            // 起点点标记拖动事件
            startMarker.on('dragend', function (params) {
                _this.search_driver_data.lng = startMarker.getPosition().lng;
                _this.search_driver_data.lat = startMarker.getPosition().lat;

                _this.circleInit();
                // if (_this.submit_data.assign_mode != 'ai') {

                _this.searchDriver(_this.search_driver_data.lng, _this.search_driver_data.lat, _this.slider_km);

                // }

                var lnglat = String(startMarker.getPosition().lng) + ',' + String(startMarker.getPosition().lat);

                _this.submit_data.start_coordinate = lnglat;

                _this.startName(lnglat);
            });

            _this.circleInit();

            if (_this.submit_data.assign_mode != 'ai') {
                _this.main_right_show = true;
            }

            _this.searchDriver(lng, lat, _this.slider_km);
        },

        // 根据坐标获取起点名称
        startName(lnglat) {
            var geocoder = new AMap.Geocoder({
                city: _this.currentCity, //城市设为北京，默认：“全国”
                radius: 500 //范围，默认：500
            });
            geocoder.getAddress(lnglat, function (status, result) {
                if (result.regeocode.addressComponent.neighborhood == '') {
                    if (result.regeocode.addressComponent.building == '') {
                        var address = result.regeocode.formattedAddress;
                    } else {
                        var address = result.regeocode.addressComponent.building;
                    }
                } else {
                    var address = result.regeocode.addressComponent.neighborhood;
                }

                _this.submit_data.start_name = address;

                // 如果起点和终点都存在，则规划驾车导航
                if (_this.submit_data.start_name != '' && _this.submit_data.end_name != '') {
                    // 规划驾车导航
                    _this.drivingLine();
                }

                _this.estimatedPrice();
            });
        },

        // 根据坐标获取终点名称
        endName(lnglat) {
            var geocoder = new AMap.Geocoder({
                city: _this.currentCity, //城市设为北京，默认：“全国”
                radius: 500 //范围，默认：500
            });
            geocoder.getAddress(lnglat, function (status, result) {
                if (result.regeocode.addressComponent.neighborhood == '') {
                    if (result.regeocode.addressComponent.building == '') {
                        var address = result.regeocode.formattedAddress;
                    } else {
                        var address = result.regeocode.addressComponent.building;
                    }
                } else {
                    var address = result.regeocode.addressComponent.neighborhood;
                }

                _this.submit_data.end_name = address;

                // 如果起点和终点都存在，则规划驾车导航
                if (_this.submit_data.start_coordinate != '' && _this.submit_data.end_coordinate != '') {
                    // 规划驾车导航
                    _this.drivingLine();
                }
                _this.estimatedPrice();
            });
        },

        // 创建终点点标记
        endMark(lng, lat) {
            if (endMarker) {
                map.remove(endMarker);
            }
            var lnglat = String(lng) + ',' + String(lat);
            _this.end.lng = lng;
            _this.end.lat = lat;
            _this.submit_data.end_coordinate = lnglat;
            // 添加终点标记
            // 创建一个 Icon
            var endIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(25, 34),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                imageSize: new AMap.Size(135, 40),
                imageOffset: new AMap.Pixel(-95, -3)
            });

            // 将 icon 传入 marker
            endMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                icon: endIcon,
                draggable: true,
                offset: new AMap.Pixel(-13, -30),
                zIndex: 999
            });

            map.add(endMarker);

            // 终点点标记拖动事件
            endMarker.on('dragend', function (params) {
                _this.end.lng = endMarker.getPosition().lng;
                _this.end.lat = endMarker.getPosition().lat;

                var lnglat = String(endMarker.getPosition().lng) + ',' + String(endMarker.getPosition().lat);

                _this.submit_data.end_coordinate = lnglat;

                _this.endName(lnglat);
            });
        },

        // 地点列表点击触发
        listClick(val, lng, lat, text) {
            // 如果地图存在标记点则清除
            if (_this.markPoint.length > 0) {
                for (let j = 0; j < _this.markPoint.length; j++) {
                    map.remove(_this.markPoint[j]);
                }
            }

            // 清除所有点标记
            map.remove(markers);
            if (val == 'start') {
                _this.submit_data.start_name = text;
                _this.submit_data.start_coordinate = String(lng) + ',' + String(lat);

                _this.search_driver_data.lng = lng;
                _this.search_driver_data.lat = lat;

                if (startMarker) {
                    map.remove(startMarker);
                }

                _this.startMark(lng, lat);

                // 如果订单模式部位AI派单，则打开选择司机窗口
                if (_this.submit_data.assign_mode != 'ai') {
                    _this.main_right_show = true;
                }

                // 如果目的地为空则地图自适应中心点
                if (_this.submit_data.end_name == '' || _this.submit_data.end_name == null) {
                    map.setFitView([startMarker]);
                }

                _this.start_panel_show = false;
                _this.circleInit();

                // 搜索司机
                _this.searchDriver(lng, lat, _this.slider_km);
            } else if (val == 'end') {
                _this.submit_data.end_name = text;
                _this.submit_data.end_coordinate = String(lng) + ',' + String(lat);
                _this.end.lng = lng;
                _this.end.lat = lat;

                if (endMarker) {
                    map.remove(endMarker);
                }

                _this.endMark(lng, lat);
                // 如果目的地为空则地图自适应中心点
                if (_this.submit_data.start_name == '' || _this.submit_data.start_name == null) {
                    map.setFitView([endMarker]);
                }

                _this.end_panel_show = false;
            }

            if (_this.submit_data.start_name != '' && _this.submit_data.end_name != '') {
                // 规划驾车导航
                _this.drivingLine();
            }

            _this.estimatedPrice();
            // 使地图自适应显示到合适的范围
            map.setZoom(15);
        },

        // 规划驾车路线
        drivingLine() {
            //driving是全局变量不用_this，vue里面的变量才要用_this

            if (driving) {
                //调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
                driving.clear();
                _this.distance = '0';
                _this.estimate = '0';
            }
            // policy: _this.strategy == 'short' ? AMap.DrivingPolicy.LEAST_DISTANCE : AMap.DrivingPolicy.LEAST_TIME
            // policy:AMap.DrivingPolicy.LEAST_TIME
            // policy:AMap.DrivingPolicy.LEAST_FEE

            // policy:AMap.DrivingPolicy.LEAST_DISTANCE

            // policy:AMap.DrivingPolicy.REAL_TRAFFIC

            //构造路线导航类
            driving = new AMap.Driving({
                map: map,
                hideMarkers: true,
                policy: _this.strategy == 'short' ? AMap.DrivingPolicy.LEAST_DISTANCE : AMap.DrivingPolicy.LEAST_TIME
            });

            driving.search(
                new AMap.LngLat(Number(_this.search_driver_data.lng), Number(_this.search_driver_data.lat)),
                new AMap.LngLat(Number(_this.end.lng), Number(_this.end.lat)),
                function (status, result) {
                    _this.distance = Math.round(result.routes[0].distance / 100) / 10;
                    _this.estimate = Math.round(result.routes[0].time / 60);

                    if (status === 'complete') {
                        log.success('绘制驾车路线完成');
                    } else {
                        log.error('获取驾车数据失败：' + result);
                    }
                }
            );
        },

        // 地图圆形初始化
        circleInit() {
            if (circle) {
                map.remove(circle);
            }

            circle = new AMap.Circle({
                center: [startMarker.getPosition().lng, startMarker.getPosition().lat],
                radius: _this.slider_km * 1000, //半径
                borderWeight: 3,
                strokeColor: 'transparent',
                strokeOpacity: 1,
                strokeWeight: 6,
                strokeOpacity: 0.2,
                fillOpacity: 0.2,
                strokeStyle: 'dashed',
                strokeDasharray: [10, 10],
                // 线样式还支持 'dashed'
                fillColor: '#1791fc',
                zIndex: 50,
                bubble: true // 将覆盖物的鼠标或touch等事件冒泡到地图上
            });
            circle.setMap(map);
        },

        // 地点输入框输入触发
        onInput(val, flag) {
            if (val != '' && val != null) {
                if (flag == '1') {
                    _this.start_panel_show = true;

                    var keywords = _this.submit_data.start_name;

                    // console.log(keywords,'===============');
                    AMap.plugin('AMap.PlaceSearch', function () {
                        var autoOptions = {
                            city: _this.area_code
                            // map: map
                        };

                        placeSearch = new AMap.PlaceSearch(autoOptions);
                        placeSearch.search(keywords, function (status, result) {
                            // console.log(result);

                            _this.start_panel_innerHtml = [];

                            if (result) {
                                // console.log(_this.markPoint);

                                // console.log(result);
                                // 如果地图存在标记点则清除
                                if (_this.markPoint.length > 0) {
                                    for (let j = 0; j < _this.markPoint.length; j++) {
                                        map.remove(_this.markPoint[j]);
                                    }
                                }
                                for (let i = 0; i < result.poiList.pois.length; i++) {
                                    // console.log(result.poiList.pois[i],'列表数据');

                                    // 添加列表内容
                                    if (result.poiList.pois[i]) {
                                        _this.start_panel_innerHtml.push(result.poiList.pois[i]);
                                        //  添加地图标记点
                                        //  markPoint
                                        var markPointIcon = new AMap.Icon({
                                            // 图标尺寸
                                            size: new AMap.Size(25, 34),
                                            // 图标的取图地址
                                            image: require(`@/assets/markPoint${i + 1}.png`),
                                            // 图标所用图片大小
                                            imageSize: new AMap.Size(30, 30),
                                            // 图标取图偏移量
                                            imageOffset: new AMap.Pixel(0, 0)
                                        });

                                        // console.log(result);
                                        // 将 icon 传入 marker
                                        _this.markPoint[i] = new AMap.Marker({
                                            position: new AMap.LngLat(
                                                result.poiList.pois[i].location.lng,
                                                result.poiList.pois[i].location.lat
                                            ),
                                            icon: markPointIcon,
                                            draggable: false,
                                            offset: new AMap.Pixel(-13, -30),
                                            zIndex: 999
                                        });

                                        _this.markPoint[i].setMap(map);
                                    }
                                }
                            }
                        });
                    });
                } else if (flag == '2') {
                    _this.end_panel_show = true;

                    var keywords = _this.submit_data.end_name;
                    AMap.plugin('AMap.PlaceSearch', function () {
                        var autoOptions = {
                            city: _this.area_code
                            // map: map
                        };
                        var placeSearch = new AMap.PlaceSearch(autoOptions);
                        placeSearch.search(keywords, function (status, result) {
                            _this.end_panel_innerHtml = [];

                            for (let i = 0; i < result.poiList.pois.length; i++) {
                                // 添加列表内容
                                if (result.poiList.pois[i]) {
                                    _this.end_panel_innerHtml.push(result.poiList.pois[i]);
                                }
                            }
                        });
                    });
                }
            } else {
                // 清除所有点标记
                map.remove(markers);

                // 清空路线规划
                if (driving) {
                    // 调用clear()函数清除上一次结果，可以清除地图上绘制的路线以及路径文本结果
                    driving.clear();
                    _this.distance = '0';
                    _this.estimate = '0';
                }

                if (flag == '1') {
                    _this.start_panel_show = false;
                    _this.start_panel_innerHtml = [];
                    _this.main_right_show = false;
                    _this.submit_data.start_coordinate = '';

                    // 如果地图存在标记点则清除
                    if (_this.markPoint.length > 0) {
                        for (let j = 0; j < _this.markPoint.length; j++) {
                            map.remove(_this.markPoint[j]);
                        }
                    }

                    if (circle) {
                        map.remove(circle);
                    }

                    if (startMarker) {
                        map.remove(startMarker);
                    }
                } else if (flag == '2') {
                    _this.end_panel_show = false;
                    _this.end_panel_innerHtml = [];
                    _this.submit_data.end_coordinate = '';

                    if (endMarker) {
                        map.remove(endMarker);
                    }
                }
            }
            _this.estimatedPrice();
        },

        // 搜索司机
        searchDriver(lng, lat, radius) {
            _this.loading = true;

            if (localStorage.getItem('order_by') == null || localStorage.getItem('order_by') == undefined) {
                var order_by_data = 'distance';
            } else {
                var order_by_data = localStorage.getItem('order_by');
            }

            _this.rightToptableData = [];
            var searchDriverData;

            if (_this.submit_data.assign_mode == 'ai') {
                searchDriverData = {
                    ws_mode: 'nearbyDriver',
                    lng: lng,
                    lat: lat,
                    search_radius: radius,
                    order_by: order_by_data,
                    num: String(_this.search_driver_num),
                    is_amap: '1',
                    order_mode_code: _this.submit_data.order_mode_code,
                    order_code: _this.submit_data.order_code,
                };
            } else {
                searchDriverData = {
                    ws_mode: 'nearbyDriver',
                    lng: lng,
                    lat: lat,
                    search_radius: radius,
                    order_by: order_by_data,
                    num: String(_this.search_driver_num),
                    is_amap: _this.actual ? '1' : '0',
                    order_mode_code: _this.submit_data.order_mode_code,
                    order_code: _this.submit_data.order_code,

                };
            }

            // 发送数据搜索司机
            _this.global.ws.send(JSON.stringify(searchDriverData));
        },

        //AI派单匹配人数滑块
        matchingSliderDriverChange(val) {
            if (val == 0) {
                _this.matching.radius_slider_num = 1;
            } else if (val == 20) {
                _this.matching.radius_slider_num = 2;
            } else if (val == 40) {
                _this.matching.radius_slider_num = 3;
            } else if (val == 60) {
                _this.matching.radius_slider_num = 4;
            } else if (val == 80) {
                _this.matching.radius_slider_num = 5;
            } else if (val == 100) {
                _this.matching.radius_slider_num = 6;
            }
        },

        // 滑块数据改变时触发
        sliderChange(val) {
            _this.slider_km = val / 5;

            if (startMarker) {
                _this.circleInit();

                _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km);
            }
        },

        sliderDriverChange(val) {
            _this.search_driver_num = val / 5;

            _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km);
        },

        // 添加司机方法
        addDriver(driver_code, name, lng, lat, status, dan) {
            // 根据司机状态决定文本标签的背景色
            switch (String(status)) {
                case '0':
                    var backgroundColor = '#B9B9B9';

                    break;
                case '1':
                    var backgroundColor = '#61D59C';

                    break;
                case '2':
                    var backgroundColor = '#00A4DC';

                    break;
                case '3':
                    var backgroundColor = '#9296F0';

                    break;
                case '4':
                    var backgroundColor = '#BBC22C';

                    break;
                case '5':
                    var backgroundColor = '#FADC05';

                    break;
                case '6':
                    var backgroundColor = '#FAB105';

                    break;

                default:
                    break;
            }

            // 如果driver_code存在,不需要新添加司机标签
            if (typeof _this.driver[driver_code] !== 'undefined') {
                // 如果接收到的数据不存在坐标并且司机标签已经存在，则只改变颜色
                if (lng != undefined && lng != null && lng != '' && lat != undefined && lat != null && lat != '') {
                    //更改司机标签的坐标
                    _this.driver[driver_code].setPosition([lng, lat]);
                }

                // 如果信息窗口存在并且已经打开
                if (_this.driverMarks_status[driver_code] && _this.driverMarks_status[driver_code].getIsOpen()) {
                    // 更改司机信息窗口的坐标
                    _this.driverMarks_status[driver_code].setPosition([lng, lat]);
                }

                _this.driver[driver_code].setStyle({
                    'background-color': backgroundColor
                });

                return;
            } else if (
                typeof _this.driver[driver_code] == 'undefined' &&
                (lng == undefined || lng == null || lng == '' || lat == undefined || lat == null || lat == '')
            ) {
                // 如果driver_code不存在而且也没有坐标点直接直接return

                return;
            }

            // 根据司机状态决定文本标签的背景色
            switch (String(dan)) {
                case '0':
                    var driver_logo = require('@/assets/11.png');

                    break;
                case '1':
                    var driver_logo = require('@/assets/22.png');

                    break;
                case '2':
                    var driver_logo = require('@/assets/33.png');

                    break;
                case '3':
                    var driver_logo = require('@/assets/44.png');

                    break;

                default:
                    break;
            }

            // 创建纯文本标记（司机标签）
            _this.driver[driver_code] = new AMap.Text({
                text:
                    '<div style="display:flex;"><img style="margin:0 auto;display:block;width:25px;height:25px;" src="' +
                    driver_logo +
                    '">' +
                    name +
                    '</div>',
                anchor: 'center', // 设置文本标记锚点
                draggable: true,
                cursor: 'pointer',
                animation: 'AMAP_ANIMATION_DROP',
                angle: 0,
                style: {
                    padding: '.5rem .5rem',
                    'margin-bottom': '1rem',
                    'border-radius': '.25rem',
                    'background-color': backgroundColor,
                    width: '',
                    'border-width': 0,
                    'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
                    'text-align': 'center',
                    'font-size': '14px',
                    color: '#fff'
                },
                position: [lng, lat]
            });

            _this.driver[driver_code].setMap(map);

            // 1秒后清除点标掉落效果的动画(防止点标抖动)
            setTimeout(() => {
                if (_this.driver[driver_code]) {
                    _this.driver[driver_code].setAnimation('AMAP_ANIMATION_NONE');
                }
            }, 1000);

            // 文本标记的点击事件
            var clickHandle = AMap.event.addListener(_this.driver[driver_code], 'click', function () {
                _this
                    .$post('/driver/getPerformance', {
                        driver_code: driver_code
                    })
                    .then((res) => {
                        if (res.data.logo_img.url == '' || res.data.logo_img.url == null) {
                            _this.url = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
                        } else {
                            _this.url = res.data.logo_img.url;
                        }

                        // 创建信息窗口
                        _this.driverMarks_status[driver_code] = new AMap.InfoWindow({
                            isCustom: true, //使用自定义窗体
                            content:
                                '<div style="width:180px;background-color:white;padding: 20px;box-sizing: border-box;border-radius: 5px">' +
                                '<div style="overflow: hidden; width:80px;height:80px;margin:0 auto;border-radius: 50%;">' +
                                '<img style="margin:0 auto;display:block;width:100%;height:100%;" src="' +
                                _this.url +
                                '">' +
                                '</div>' +
                                '<h4 style="text-align: center;font-weight: bold;font-size: 18px">' +
                                name +
                                '</h4>' +
                                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">今日完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                                res.data.today_order_nums +
                                '单</span> </p>' +
                                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">本月完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                                res.data.month_order_nums +
                                '单</span> </p>' +
                                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">任职状态</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                                res.data.capacity +
                                '</span> </p>' +
                                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">综合指数</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                                res.data.exponent_driver_points_ +
                                '分</span> </p>' +
                                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">司机电话</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                                res.data.phone +
                                '</span> </p>' +
                                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">定位时间</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                                res.data.position_time.YmdHis +
                                '</span> </p>' +
                                '</div>',
                            offset: new AMap.Pixel(0, -20)
                        });

                        //打开信息窗口
                        _this.driverMarks_status[driver_code].open(map, _this.driver[driver_code].getPosition()); //后面的参数指的是经纬度，在此显示窗口
                    })
                    .catch((err) => {});
            });
        },

        // 关闭测距功能
        closeRanging() {
            ruler1.turnOff();
        },

        // 管理司机信息窗口方法
        closePop() {
            // 遍历关闭信息窗口
            for (const key in _this.driverMarks_status) {
                _this.driverMarks_status[key].close();
            }

            if (_this.start_panel_show) {
                _this.start_panel_show = false;
            }

            if (_this.end_panel_show) {
                _this.end_panel_show = false;
            }
        },

        // 获取地图优惠券在地图上渲染优惠券
        getMapCouponList(code) {
            if (code) {
                // console.log(code, 'code是优惠券编码');
                // console.log(_this.couponMarker[code], '_this.couponMarker111111111111');
                map.remove(_this.couponMarker[code]);
                // console.log(_this.couponMarker, '_this.couponMarker333333');
            }

            _this
                .$post('/map/getMapCouponList')
                .then((res) => {
                    // 在地图上添加优惠券图片

                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            // console.log(res.data[i],i);
                            let postData = res.data[i];
                            // console.log(postData, i);
                            _this.addCouponMark(res.data[i]);
                        }
                    }
                })
                .catch((err) => {});
        },

        // 获取订单模式列表
        async orderModeLists() {
            // console.log(_this.area_code);
            // 2024-06-21订单模式优化，参数变更，导致订单模式返回了三方模式，应老胡需求，订单模式去掉三方模式，庄哥把接口重命名，当前接口返回的订单模式已排除三方

            await new Promise((resolve, reject) =>{
                _this
                .$post('/order/orderModeListsOld', {
                    page: 1,
                    limit: 50,
                    status: '1',
                    not_openapi: '1',
                    is_man:this.is_man
                })
                .then((res) => {
                    _this.value_order_array = res.data;

                    if (res.data.length == 0) {
                        _this.submit_data.order_mode_code = '';
                    } else {
                        [
                            {
                                mode: {
                                    order_mode_code: 'XXX'
                                }
                            }
                        ];

                        for (let i = 0; i < _this.value_order_array.length; i++) {
                            // 如果缓存中存在模式,并且该模式存在在模式列表中(模式有效)，则设置成默认选择的模式
                            // 第一次进入代驾订单页面，或者是创单后不刷新页面，则订单模式显示的是上一次创建订单选择的模式，如果是第一次进入代驾订单页面或者刷新页面，则显示默认模式
                            if (
                                localStorage.getItem('order_mode') &&
                                _this.value_order_array[i].order_mode.order_mode_code == localStorage.getItem('order_mode')
                            ) {
                                _this.submit_data.order_mode_code = localStorage.getItem('order_mode');
                                break;
                            } else {
                                _this.submit_data.order_mode_code = _this.value_order_array[i].order_mode.order_mode_code;
                            }
                            _this.strategy = _this.value_order_array[i].strategy;
                        }
                    }

                    resolve();

                })
                .catch((err) => {});
            })



        },

        // 按钮功能
        ThingsDeg(index) {
            // 通过传过来的index值进行判断
            switch (index) {
                case 0:
                    // 判断开关是否开启
                    if (this.isVisible) {
                        // 隐藏路况图层
                        trafficLayer.hide();
                        // 关闭开关
                        this.isVisible = false;
                    } else {
                        // 显示路况图层
                        trafficLayer.show();
                        // 开启开关
                        this.isVisible = true;
                    }

                    break;
                case 1:
                    // 切换标准主题
                    map.setMapStyle(this.btn[index].name);
                    break;
                case 2:
                    //切换黑夜主题
                    map.setMapStyle(this.btn[index].name);
                    break;
                case 3:
                    //开启测距功能
                    ruler1.turnOn();
                    break;
            }
        },

        // 获取优惠券列表
        CouponModeLists() {
            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    _this.mapCouponArray = res.data;
                    _this.selectPages_coupon_data = res;
                })
                .catch((err) => {});
        },
        selectPages_coupon_function(search_data) {
            _this.coupon_options_data.page = search_data;

            _this.CouponModeLists();
        },
        // couponList() {
        //     _this
        //         .$post('/coupon/CouponModeLists', _this.coupon_options_data)
        //         .then((res) => {
        //             _this.selectPages_coupon_data = res;
        //             _this.options_coupon_code = res.data;
        //         })
        //         .catch((err) => {});
        // },
        // 获取优惠券剩余数量
        getGrantMapCouponNum() {
            _this
                .$post('/map/getGrantMapCouponNum', {
                    coupon_mode_code: _this.getCouponCode
                })
                .then((res) => {
                    _this.mapCouponDataDisplay.surplus_num = res.data.surplus_num;
                })
                .catch((err) => {});
        }
    }
};
</script>
<style scoped>
@import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';

.box {
    border-radius: 5px;
    border: 1px solid #ddd;
    overflow: hidden;
    height: 100vh;
}

#container {
    width: 100%;
    height: 100vh;
}

.main-left {
    position: absolute;
    left: 25px;
    top: 25px;
    z-index: 1;
    width: 320px;
}

.main-left-title {
    text-align: right;
    height: 32px;
    line-height: 32px;
    padding-right: 5px;
}

.fs14-w500 {
    font-size: 14px !important;
    font-weight: 500 !important;
}

.main-right {
    position: absolute;
    left: 350px;
    top: 25px;
    margin: 0 10px;
}

.main-right-ai {
    position: absolute;
    left: 350px;
    top: 25px;
    width: 500px;
    margin: 0 10px;
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 5px 5px 10px rgb(168, 168, 168);
}

.demonstration {
    margin-left: 10px;
}

.put-long {
    width: 800px !important;
}

.right-top {
    width: 450px;
    overflow-y: auto;
    position: relative;
    float: left;
    /* max-height: 280px; */
    margin-right: 10px;
}

.right-top-search-btn-group {
    position: absolute;
    right: 10px;
    top: 5px;
}

.main-left > div,
.main-right > div {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 5px 5px 10px rgb(168, 168, 168);
}

.red-money {
    position: absolute;
    right: 25px;
    top: 25px;
    border-radius: 5px;
    padding: 5px;
    background-color: #fff;
    box-shadow: 5px 5px 10px rgb(168, 168, 168);
    font-size: 16px;
    color: #495057;
    width: 500px;
}

.row-item div {
    display: flex;
    justify-content: center;
    margin: 5px 0;
}

.red-money.details .row-item > div > p {
    width: auto;
}

.red-money.details .row-item > div > span {
    color: rgb(233, 161, 6);
    width: auto;
    height: auto;
    font-weight: bold;
}

.red-money-word {
    width: 330px;
    text-align: left;
}

.red-father {
    display: flex;
}

.red-money-style {
    width: 120px;
    text-align: right;
}

.button-group {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
}

.left-top-col {
    padding: 5px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
}

.left-bottom {
    padding-bottom: 20px !important;
}

.consumer-bottom {
    margin: 0 auto;
    background-color: #fff !important;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 10px 10px 10px rgb(168, 168, 168);
    overflow-y: auto;
    position: absolute;
    left: -10px;
    top: 50px;
}

.consumer-bottom.active {
    /* top: 710px; */
}

.need-driver {
    position: absolute;
    bottom: 100px;
    right: 25px;
    z-index: 1;
    background-color: #fff;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 10px 10px 10px rgb(168, 168, 168);
}

.title {
    color: rgb(129, 129, 129);
    border-bottom: 1px solid #eee;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    text-indent: 10px;
    position: relative;
    font-weight: 500;
    color: #111213;
}

.block {
    width: 95%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.block span {
    display: block;
    height: 30px;
    line-height: 30px;
}

.el-slider {
    width: 65%;
    transform: translate(-5%, -10%);
}

.slider-driver {
    transform: translate(-8%, -10%);
}

.input-place {
    display: inline-block;
    width: 90%;
}

#start-panel,
#end-panel {
    position: absolute;
    background-color: white;
    overflow-y: auto;
    top: 45px;
    right: 10px;
    width: 280px;
    z-index: 9999;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
}

#container .amap-controls {
    left: 100px !important;
    top: 100px !important;
}

.btnGroup {
    position: absolute;
    right: 35px;
    bottom: 20px;
    z-index: 1;
}

.checkboxGroup {
    position: absolute;
    top: 25px;
    left: 30px;
    padding: 10px 20px;
    z-index: 1;
    background-color: #fff;
    border-radius: 20px;
    min-width: 1000px;
}

.el-checkbox {
    font-weight: bolder !important;
}

.el-checkbox.is-checked {
    color: red;
}

.city-box {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999999999;
}

.pull {
    display: flex;
    padding: 20px 5px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-100%, -50%);
    transition: all 0.1s linear;
    justify-content: center;
}

.city-group {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    max-width: 300px;
    max-height: 500px;
    box-shadow: 1px 1px 5px #ccc;
    background-color: #fff;
    cursor: pointer;
    overflow-y: auto;
}

.city-group .city-name {
    padding-left: 20px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.city-group .city-name:hover {
    background-color: #ccc;
    transition: 0.2s;
}

.active {
    background-color: #ccc;
}

.table {
    position: absolute;
    top: 100px;
    left: 30px;
    z-index: 1;
    width: 300px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 5px #ccc;
}

.table-more {
    position: absolute;
    top: 100px;
    left: 350px;
    z-index: 1;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 5px #ccc;
    width: 500px;
    padding: 10px;
}

.table-more-header {
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.el-icon-refresh:hover {
    cursor: pointer;
    color: #0f9ce3;
}

.table-text {
    font-size: 14px;
    font-weight: 400;
}
</style>
<style>
.consumer-phone-wrap .el-radio-button--mini .el-radio-button__inner {
    padding: 5px 8px !important;
}

.input-place > input {
    border: none !important;
}

.amap_lib_placeSearch_page {
    display: none !important;
}

.list {
    cursor: pointer;
    padding: 10px;
    transition: 0.5s;
    display: flex;
}

.list:hover {
    background-color: #eee;
}

.list-name {
    color: #409eff;
    font-size: 14px;
    display: flex;
}

.checkboxGroup > .el-checkbox > .el-checkbox__label {
    font-weight: 800;
}

.checkboxGroup > .el-checkbox:first-of-type > .el-checkbox__label {
    color: #b9b9b9 !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(2) > .el-checkbox__label {
    color: #61d59c !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(3) > .el-checkbox__label {
    color: #00a4dc !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(4) > .el-checkbox__label {
    color: #9296f0 !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(5) > .el-checkbox__label {
    color: #bbc22c !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(6) > .el-checkbox__label {
    color: #fadc05 !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(7) > .el-checkbox__label {
    color: #fab105 !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(8) > .el-checkbox__label {
    color: #fa6705 !important;
}

.checkboxGroup > .el-checkbox:nth-of-type(9) > .el-checkbox__label {
    color: #fa4705 !important;
}

.add-order-btn {
    position: fixed;
    right: 130px;
    top: 70px;
    z-index: 1;
    padding: 8px 15px;
}

.appointment-table.el-table thead tr th,
.right-top .el-table thead tr th,
.consumer-bottom .el-table thead tr th {
    color: #606266;
    background-color: #d5e9fc !important;
    border-bottom: 1px solid #afd7fd;
}

.main-right .el-table__fixed-right::before,
.el-table__fixed::before {
    background-color: transparent !important;
}
</style>
<style>
.red-money .el-input {
    width: 200px;
}
</style>
